/**
 * Luohuo IM - Shopify DTC 客服浮窗 Widget
 *
 * 使用方式：在 Shopify 主题编辑器 -> 自定义代码 -> theme.liquid 的 </body> 前粘贴：
 *
 * <script>
 *   window.LuohuoIMConfig = {
 *     apiBase: 'https://api-test.sigencloud.com',
 *     appProxyPath: '/apps/im-chat',       // Shopify App Proxy 路径前缀
 *     wsUrl:  'wss://api-test.sigencloud.com/luohuo-ws/ws',
 *     shopifyCustomerId: '',               // Shopify logged_in_customer_id（已登录时由 Liquid 注入）
 *     shopifyCustomerName: '',             // 已登录用户名（由 Liquid 注入）
 *     shopifyCustomerEmail: ''             // 已登录用户邮箱（由 Liquid 注入）
 *   };
 * </script>
 * <script src="https://your-cdn.com/shopify-widget.js"></script>
 *
 * 流程说明：
 * 1. 用户点击浮窗 -> 已登录用户直接进入聊天；游客需输入邮箱和用户名后点击 Start 进入
 * 2. 进入聊天后调用 DTC 会话列表接口，若无会话或所有会话状态为 3(结束)，则创建新会话
 * 3. 建立 WebSocket 长连接，AI 回复以流式逐字展示
 * 4. 加载推荐问题卡片，用户可点击发送
 * 5. 用户可自定义输入问题，AI 回答
 * 6. 提供转人工按钮，随时可转人工
 * 7. 提供 Restart 按钮，重新创建会话
 */
(function () {
  'use strict';

  // ─── 读取外部配置 ────────────────────────────────────────────────────────────
  var cfg = window.LuohuoIMConfig || {};
  var APP_PROXY_PATH = cfg.appProxyPath || '/apps/im-chat';
  var WS_URL = cfg.wsUrl || 'wss://api-test.sigencloud.com/sigen-ws/ws';
  var SHOPIFY_CUSTOMER_ID = cfg.shopifyCustomerId || '';
  var SHOPIFY_CUSTOMER_NAME = cfg.shopifyCustomerName || '';
  var SHOPIFY_CUSTOMER_EMAIL = cfg.shopifyCustomerEmail || '';
  var WS_RECONNECT_DELAY = 3000;
  var ATTACHMENT_UPLOAD_PATH = cfg.uploadPath || '/admin/sys-file/upload/public';
  var MAX_ATTACHMENT_SIZE = 200 * 1024 * 1024;
  var CHAT_PAGE_SIZE = 10;
  var HUMAN_TRANSFER_AI_REPLY_THRESHOLD = 3;
  var CONTACT_URLS = {
    de: 'https://de-store.sigenergy.com/pages/contact',
    eu: 'https://eu-store.sigenergy.com/pages/contact'
  };
  var FAQ_URLS = {
    de: 'https://de-store.sigenergy.com/pages/faq',
    eu: 'https://eu-store.sigenergy.com/pages/faq'
  };
  var PRIVACY_POLICY_URLS = {
    de: 'https://de-store.sigenergy.com/pages/privacy-policy',
    eu: 'https://eu-store.sigenergy.com/pages/privacy-policy'
  };
  var LHIM_LOCALE_STRINGS = window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.lhim || {};

  function getLhimString(key, fallback) {
    var value = LHIM_LOCALE_STRINGS[key];
    if (typeof value !== 'string' || !value || value.indexOf('translation missing:') === 0) return fallback;
    return decodeHtmlEntities(value);
  }

  function decodeHtmlEntities(value) {
    var textarea = document.createElement('textarea');
    textarea.innerHTML = String(value || '');
    return textarea.value;
  }

  var WELCOME_PROMPT = getLhimString('welcomePrompt', 'Hello! Welcome to Sigenergy Support.To help us assist you more efficiently, please briefly describe your question or issue — include product model if relevant, and we\'ll help you as quickly as possible.');
  var SUPPORT_HOURS_PROMPT = getLhimString('supportHoursPrompt', 'Our support hours are Mon–Fri, 9:00–18:00 CET. Sorry for the wait — our live agents may be busy right now. You can also email us at support.consumer@sigenergy.com, and we’ll get back to you as soon as possible.');
  var HUMAN_AGENT_GREETING_PROMPT = getLhimString('humanAgentGreetingPrompt', 'You\'ve been connected to a live agent. We\'ll be with you shortly - feel free to add any extra details you\'d like us to know.');
  var CANCEL_ORDER_PROMPT = getLhimString('cancelOrderPrompt', [
    "We're sorry to see you go. To help us locate your order, please share your order number (it starts with #, you can find it in your order confirmation email).",
    '',
    "One quick question to help us improve: what's the main reason you're cancelling?",
    '',
    'A. The wait time is too long',
    'B. Found a better price elsewhere',
    'C. Changed my mind / no longer need it',
    'D. Ordered by mistake',
    'E. Other (tell us more)'
  ].join('\n'));
  var NEW_MESSAGE_LABEL = getLhimString('newMessage', 'New Message');
  var LOADING_CONVERSATION_LABEL = getLhimString('loadingConversation', 'Loading conversation...');
  var GUEST_FORM_TITLE_PREFIX = getLhimString('guestFormTitlePrefix', 'Welcome to');
  var GUEST_FORM_TITLE_BRAND = getLhimString('guestFormTitleBrand', 'Sigenergy Support');
  var GUEST_FORM_DESCRIPTION = getLhimString('guestFormDescription', "Hello! To help us assist you more efficiently, please briefly describe your question or issue — include product model if relevant, and we'll help you as quickly as possible.");
  var GUEST_EMAIL_PLACEHOLDER = getLhimString('guestEmailPlaceholder', 'Email *');
  var GUEST_NAME_PLACEHOLDER = getLhimString('guestNamePlaceholder', 'Name *');
  var GUEST_CONSENT_PREFIX = getLhimString('guestConsentPrefix', 'I agree that Sigenergy may record this conversation. For more information, please read our');
  var GUEST_PRIVACY_POLICY_LABEL = getLhimString('guestPrivacyPolicyLabel', 'Privacy Policy');
  var GUEST_START_LABEL = getLhimString('guestStartLabel', 'Start');
  var FAQS_LABEL = getLhimString('faqsLabel', 'FAQs');
  var CONTACT_US_LABEL = getLhimString('contactUsLabel', 'Contact us');
  var MORE_LABEL = getLhimString('moreLabel', 'More');
  var HUMAN_AGENT_LABEL = getLhimString('humanAgentLabel', 'Human Agent (Mon–Fri, 9:00–18:00 CET)');
  var RESTART_LABEL = getLhimString('restartLabel', 'Restart');
  var CANCEL_ORDER_LABEL = getLhimString('cancelOrderLabel', 'Cancel Order');
  var MESSAGE_INPUT_PLACEHOLDER = getLhimString('messageInputPlaceholder', 'Describe your issue...');
  var ADD_ATTACHMENT_LABEL = getLhimString('addAttachmentLabel', 'Add attachment');
  var SEND_LABEL = getLhimString('sendLabel', 'Send');
  var CHAT_START_LABEL = getLhimString('chatStartLabel', 'Start');
  var STATUS_CONNECTED = getLhimString('statusConnected', 'Connected');
  var STATUS_CONVERSATION_ENDED = getLhimString('statusConversationEnded', 'Conversation ended.');
  var STATUS_INITIALIZING = getLhimString('statusInitializing', 'Initializing...');
  var STATUS_FAILED_TO_LOAD_SESSIONS = getLhimString('statusFailedToLoadSessions', 'Failed to load sessions. Please retry.');
  var STATUS_CREATING_CONVERSATION = getLhimString('statusCreatingConversation', 'Creating conversation...');
  var STATUS_FAILED_TO_CREATE_CONVERSATION = getLhimString('statusFailedToCreateConversation', 'Failed to create conversation. Please retry.');
  var STATUS_BACK_TO_AI_SUPPORT = getLhimString('statusBackToAiSupport', 'Back to AI support.');
  var STATUS_START_NEW_CONVERSATION = getLhimString('statusStartNewConversation', 'Please start a new conversation to continue.');
  var STATUS_FAILED_TO_SEND = getLhimString('statusFailedToSend', 'Failed to send. Please retry.');
  var STATUS_NETWORK_ERROR = getLhimString('statusNetworkError', 'Network error. Please retry.');
  var STATUS_START_CONVERSATION_BEFORE_UPLOAD = getLhimString('statusStartConversationBeforeUpload', 'Please start a conversation before uploading.');
  var STATUS_FILE_TOO_LARGE = getLhimString('statusFileTooLarge', 'File is too large. Maximum size is 200MB.');
  var STATUS_NO_ATTACHMENT_SELECTED = getLhimString('statusNoAttachmentSelected', 'No attachment selected.');
  var STATUS_UPLOADING_ATTACHMENT = getLhimString('statusUploadingAttachment', 'Uploading attachment...');
  var STATUS_ATTACHMENT_SENT = getLhimString('statusAttachmentSent', 'Attachment sent.');
  var STATUS_ATTACHMENT_UPLOAD_FAILED = getLhimString('statusAttachmentUploadFailed', 'Attachment upload failed. Please retry.');
  var STATUS_TRANSFERRING_TO_HUMAN = getLhimString('statusTransferringToHuman', 'Transferring to a human agent...');
  var STATUS_CURRENTLY_CONNECTED_TO_HUMAN = getLhimString('statusCurrentlyConnectedToHuman', 'Currently connected to a human agent.');
  var STATUS_CONNECTED_TO_HUMAN = getLhimString('statusConnectedToHuman', 'Connected to a human agent.');
  var STATUS_TRANSFER_FAILED = getLhimString('statusTransferFailed', 'Transfer failed. Please try again.');
  var STATUS_CONNECTION_ERROR = getLhimString('statusConnectionError', 'Connection error');
  var LHIM_AI_AVATAR_SVG = '<svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1084 15.5039C14.4549 15.1618 15.0127 15.1659 15.3545 15.5127C15.6963 15.8598 15.6932 16.4193 15.3467 16.7617C13.7651 18.3245 11.0766 19.0156 8.95117 19.0156C6.83943 19.0156 4.20682 18.3379 2.61426 16.8145C2.26228 16.4777 2.24882 15.918 2.58496 15.5654C2.92119 15.2128 3.48002 15.2003 3.83203 15.5371C5.08221 16.7331 7.31443 17.2499 8.95117 17.25C10.5901 17.25 12.872 16.7256 14.1084 15.5039ZM15.8564 4.4375C16.3969 4.4375 16.835 4.87659 16.835 5.41797V9.5791C16.835 10.606 16.4306 11.5919 15.709 12.3213C14.9875 13.0506 14.0073 13.4642 12.9824 13.4736H5.05273C4.02163 13.4736 3.03282 13.0634 2.30371 12.333C1.5746 11.6026 1.16504 10.612 1.16504 9.5791V8.33203C1.16512 7.29917 1.5746 6.30848 2.30371 5.57812C3.03281 4.84783 4.02168 4.43758 5.05273 4.4375H15.8564Z" fill="#16DEEB"/><path d="M2.30285 5.56265C3.03201 4.83222 4.02097 4.42188 5.05215 4.42188H15.8553C16.7686 4.42188 16.8338 5.40212 16.8338 5.40212L15.0057 6.22579L4.82035 11.7102C4.82035 11.7102 4.42861 12.1517 4.03686 12.559C3.64512 12.9663 3.38395 13.0817 3.38395 13.0817C3.38395 13.0817 2.62003 12.6354 2.30285 12.3176C1.5737 11.5872 1.16406 10.5965 1.16406 9.56357V8.31671C1.16406 7.28374 1.5737 6.29307 2.30285 5.56265Z" fill="#A9FCFF" fill-opacity=".7"/><path d="M2.93457 8.40962C2.93457 7.25573 3.86999 6.32031 5.02388 6.32031H14.9481V9.71544C14.9481 10.8693 14.0127 11.8047 12.8588 11.8047H5.02388C3.86998 11.8047 2.93457 10.8693 2.93457 9.71544V8.40962Z" fill="#F0FEFF"/><path d="M15.9289 2.84562H12.1598C12.0029 2.84563 11.8524 2.78401 11.741 2.67418C11.6296 2.56436 11.5663 2.41521 11.5649 2.2592V1.59947C11.5676 1.44339 11.6312 1.29446 11.7422 1.18408C11.8531 1.0737 12.0029 1.0105 12.1598 1.00781H16.4974V2.23302C16.5009 2.31005 16.4892 2.38701 16.4628 2.45951C16.4363 2.53201 16.3958 2.59861 16.3435 2.65551C16.2912 2.71242 16.2281 2.7585 16.1579 2.79112C16.0876 2.82374 16.0116 2.84226 15.9341 2.84562" fill="#25D8E3"/></svg>';
  var LHIM_AI_AVATAR_DATA_URI = 'data:image/svg+xml,' + encodeURIComponent(LHIM_AI_AVATAR_SVG);
  var LHIM_SERVICE_ICON_SVG = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.605 5.94231H11.7501C11.7501 3.71991 9.95543 1.92525 7.81836 1.92525C5.68183 1.92525 3.88663 3.71991 3.88663 5.94231H3.03223C3.03223 3.29271 5.16876 1.07031 7.81836 1.07031C10.468 1.07031 12.605 3.20685 12.605 5.94231Z" fill="#1B2438"/><path d="M4.57043 11.263H4.14377C3.7392 11.2648 3.33828 11.1864 2.96416 11.0324C2.59004 10.8784 2.25012 10.6518 1.96402 10.3658C1.67792 10.0797 1.4513 9.73986 1.29724 9.36577C1.14318 8.99168 1.06474 8.59077 1.06643 8.1862C1.06474 7.78163 1.14318 7.38073 1.29724 7.00664C1.4513 6.63254 1.67792 6.29266 1.96402 6.00661C2.25012 5.72056 2.59004 5.494 2.96416 5.34001C3.33828 5.18602 3.7392 5.10764 4.14377 5.1094H4.57043V11.263ZM3.71603 5.9638C2.69043 6.135 1.92137 7.07527 1.92137 8.1862C1.92137 9.29767 2.69043 10.1521 3.71603 10.4086V5.9638ZM11.323 11.263H10.8952V5.1094H11.323C11.7276 5.10764 12.1285 5.18603 12.5027 5.34006C12.8769 5.49408 13.2168 5.72069 13.5029 6.0068C13.789 6.29291 14.0156 6.63285 14.1696 7.00701C14.3237 7.38116 14.4021 7.78212 14.4003 8.18674C14.4019 8.59126 14.3234 8.99211 14.1693 9.36614C14.0152 9.74017 13.7886 10.08 13.5025 10.366C13.2164 10.652 12.8765 10.8785 12.5024 11.0325C12.1284 11.1864 11.7275 11.2648 11.323 11.263ZM11.7502 5.9638V10.3233C12.7758 10.1526 13.5454 9.2118 13.5454 8.10087C13.5454 7.07527 12.7758 6.22034 11.7502 5.9638Z" fill="#1B2438"/><path d="M8.58794 13.3755V12.5206C9.69887 12.5206 10.5533 12.2646 11.0663 11.7515C11.5794 11.2384 11.5794 10.6406 11.5794 10.5547H12.4338C12.4338 10.5547 12.4338 11.5808 11.6647 12.3499C11.0663 13.0336 10.0407 13.3755 8.5874 13.3755H8.58794Z" fill="#1B2438"/><path d="M7.98924 14.4002C7.30604 14.4002 6.79297 13.8018 6.79297 13.1181C6.79297 12.4343 7.30604 11.8359 7.98977 11.8359C8.6735 11.8359 9.18604 12.4343 9.18604 13.1181C9.18604 13.8018 8.6735 14.4002 7.98977 14.4002H7.98924ZM7.98924 12.7762C7.81857 12.7762 7.6479 12.9469 7.6479 13.2034C7.6479 13.4599 7.81857 13.6311 7.98924 13.6311C8.16044 13.6311 8.33164 13.4605 8.33164 13.2034C8.33164 12.9474 8.16097 12.7767 7.98977 12.7767L7.98924 12.7762Z" fill="#1B2438"/></svg>';
  var LHIM_SERVICE_ICON_DATA_URI = 'data:image/svg+xml,' + encodeURIComponent(LHIM_SERVICE_ICON_SVG);
  var LHIM_FAQ_ICON_DATA_URI = 'data:image/svg+xml;base64,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';
  var LHIM_ATTACHMENT_ICON_DATA_URI = 'data:image/svg+xml;base64,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';
  var LHIM_CANCEL_ICON_DATA_URI = 'data:image/svg+xml;base64,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';
  var LHIM_GUEST_LOGO_DATA_URI = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAOdEVYdFNvZnR3YXJlAEZpZ21hnrGWYwAABmVJREFUeAHlV01sFFUc/7+P2d1uC/0kpCnSVhI1GgWNiagH6omDMYGzh9ajN4yJ5yUhXgXjhYOhCAkKmvQgxouhmKgxMdAaA2hiuo2kDUK723Z3Zndm3nv+3pvZdtstLcR68t/Ovo957/1//+83RDtMBWP4WWO8kWtGGmPYduu3XfA4dM6YXC6KDjLtHVYUka907KNTpTgKDEVBaOJi3VSuDOy6yhgzdo+knSJImwtojy/okzyPXpaaUYZzUkyRiTlxMrTIlLkV+PMX7u16CjuqOwqgAG2CT76mdFeH5GCOSU0UA0hJKboT1M2NSsAq2jBeJNHYx2mHqMCYzitahrw/l5Q2S7GmMtrZWp1u+TX6Kwxhbmb6iH038AqFjX076gPW+fqJ+pVPe4QOa9VQLWd72vx4mZy9o91kwiIF7wyzGv1XZKPAPo+6fksNfGXMoCIaon9JMl7rZyUV32RsdksAXxgzajSdQKAc2vjObNjUGK+bN/bfwOIGfoieRgxiWmG8YLQ/XQ9eu9jdPe3AtTAPzbhRNIq1lMOPAApjEgZmA2P32Hdsra/xZxlBAIL2KNSaQgx89O8pTTP1KG+0PoZhK4ArkfmIMRoVOGAliuj3ekgrsSI4Mw4ztCVZaS0YyxyAYrT2UZqT5oakh9BkgpYAYrdYc5FVAJeNOSIUnciC0a9Vn3zo7Gg+S715QR4O1A1JrZTNEqe4VPrOkk6141pI1I6ov7zk0wrWqBAOoXUrAIg4hrW0FEFiZJS327MkMaFwUqQTBkondnQSwuKWoWLagVApw6S1+/BYg+CMPYI5gVSmwWxNA6s9rD9kGd2pa3opk6E8486pbMZubgVzI4yxGMyTjM7cO56uS1Sh3SxPzkbmscmYpYbUrQAw5wDUlEc9MpmG6VzOdIyxlduNJlGbze4OFHM9N++gYSzSg3kaH/ZXC0mGC9LKNLFvAuAhXwcwTwi4bZBSpHLZP5FKyZFfRBpzthUOhnZPitlFDVnt2cSL+YYAJIRFR5Z9kws0mUArWz5dvLI0oJ0kxqQaAACWStkwCSMHKmGWqNvqm6eM+ar28OSSzc5EfBMA9diUH4QRNECOkWxi1nwYT6W35dyp2bXMJR3XWtune3mTAFkcKFlylhdTuQVAVeup+bBOFdjopwALecrcpIZIGaDEOwASHQ6kEo91TNEYpz7BU43YuSrW3wbnu/W6A+HJcLrBdzUMV2I9Hqh4ZCkO6GuWp1fbiPbibajI2dceKAW5sNIsUb+ixDds23hsSAZYYB3aliQL+GPMP6ljmqr41MlZ8fP+/skG33W14L25xZt/BNGh3bk8yV0d9LxHdABMI5OAiNMdOjWR1QRPg58l5ncebs1YR78CAaYwfiaO6Ye5B+RDOz1cjF3a13e+RQOW9re1HX8QqslFvzrYVqvSDZGhuawHFSbqtc7BnINgDAQCni1sOoDZeKPwgHmM9B1BYmQ0exGkqwCQk5I6JTt5aaDvQjPPlmpYmC8NFcOoUIr16Aqyoru6QJcZHGAdw4WVSHTLRBr/LvKSAoRCg1gHY4CwoFECqN3j5XbiJy/s6z2d+p1+KIAGnZgpDZWofrzq7gO8yzqZh2JidWYTIE43Vn1Kaybd5RNuiotpWraAA7mBUPez/FpPhW6eHu4uN/HcprL9r+kbY3Z/tlQ7+uHd5V7aIfo0DA+eCoLBzd6tuzxaG2ZCfTYn+bcLnvrl1Nzmmx6VzpVM15dBfRw1Y+r7xYUp+FXXlgDs59KsXzscoSb0STm0wIPiB/dKhVOlxwdyMQhHfRFMKaVHa/guyCivq5aLW+6YLVHw7uzfo7eD2vizuA093ZGn+/jAwK0K4cQnsoxNZJFb3u/umN5MWpMJj1SYGUFojGFt1wDK7/RKlX6sBtQuxfnL+/eObQvA0sjNmaE4Q5OdUg6+3tlBe9syZL8kKpRkQZbUhCKlZRvfgV1QXlcG850sef6E1NeXK4RvknKnlytceaL3zGa8tvouYId/mxmFZxS6PTn4XL6NDuRz1JuRyIDIhK7oJGTvjCHMdh+X2Dt+QNOQOJa83MH5mT4KT48PD5cfyoQegY7dnhmZx1UaTvpGlokXckhIHV5yC7WXTh9Jp5rcTmc9Ia/lOV3PiGhiYgvGjwVgHSFS3pqdHSqtmMFFrngOeV5mczP5wJQmX9ye4Ub6BzuIFvR2ADdRAAAAAElFTkSuQmCC';

  // ─── 运行时状态 ──────────────────────────────────────────────────────────────
  var ws = null;
  var heartbeatTimer = null;
  var reconnectTimer = null;
  var currentRoomId = null;
  var currentUid = '';
  var messages = [];
  var isOpen = false;
  var isLoggedIn = !!SHOPIFY_CUSTOMER_ID;
  var conversationMode = 'ai';
  var guestName = '';
  var guestEmail = '';
  var fingerprint = '';
  var streamingByMsgId = {};
  var activeAiStream = null;
  var interruptedAiRoomId = null;
  var ignoredInterruptedMsgIds = {};
  var interruptedAiUntil = 0;
  var moreCloseTimer = null;
  var historyCursor = null;
  var hasMoreHistory = false;
  var loadingMoreHistory = false;
  var cancellingOrder = false;
  var sessionEnded = false;
  var pendingHumanTransfer = false;
  var transferringToHuman = false;
  var localAiReplyCount = 0;
  var pendingLocalAiReplyCount = 0;
  var countedLocalAiReplyIds = {};
  var waitingRemoteStreamEnd = false;
  var waitingRemoteStreamRoomId = '';
  var realtimeMessageOrder = 0;

  // ─── Fingerprint 管理 ────────────────────────────────────────────────────────
  function getFingerprint() {
    if (fingerprint) return fingerprint;
    var stored = localStorage.getItem('lhim_fingerprint');
    if (stored) {
      fingerprint = stored;
    } else {
      fingerprint = generateUUID();
      localStorage.setItem('lhim_fingerprint', fingerprint);
    }
    return fingerprint;
  }

  function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0;
      var v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  // ─── 注入样式 ────────────────────────────────────────────────────────────────
  var STYLE = [
    /* 触发按钮 */
    '#lhim-trigger{position:fixed;bottom:24px;right:24px;width:64px;height:64px;padding:0;border:0;background:transparent;',
    'cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:99998;',
    'transition:transform .2s,filter .2s;-webkit-tap-highlight-color:transparent;}',
    '#lhim-trigger:hover{transform:scale(1.06);filter:brightness(1.03);}',
    '#lhim-trigger:focus-visible{outline:2px solid rgba(0,200,215,.45);outline-offset:3px;border-radius:50%;}',
    '#lhim-trigger .lhim-trigger-icon{position:relative;width:64px;height:64px;filter:drop-shadow(0 4px 8px rgba(33,133,165,.4)) drop-shadow(0 10px 22px rgba(0,200,215,.28));}',
    '#lhim-trigger .lhim-trigger-icon svg{display:block;width:64px;height:64px;}',
    '#lhim-trigger .lhim-badge{position:absolute;top:4px;right:3px;background:#ff6d6d;color:transparent;',
    'border:2px solid #fff;border-radius:50%;width:12px;height:12px;font-size:0;line-height:0;display:none;',
    'align-items:center;justify-content:center;box-shadow:0 1px 3px rgba(27,36,56,.16);box-sizing:border-box;}',

    /* 聊天窗口 */
    '#lhim-window{position:fixed;bottom:90px;right:24px;width:360px;height:min(630px,calc(100vh - 112px));background:#fff;',
    'border-radius:12px;box-shadow:3px 6px 14px rgba(0,0,0,.1),11px 24px 26px rgba(0,0,0,.09),24px 54px 36px rgba(0,0,0,.05),43px 96px 42px rgba(0,0,0,.01);display:none;flex-direction:column;',
    'z-index:99999;overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;}',
    '#lhim-window.lhim-open{display:flex;}',
    '#lhim-window.lhim-chat-mode{width:360px;height:min(630px,calc(100vh - 112px));background:#eaf2fb;}',

    /* 头部 */
    '#lhim-header{background:linear-gradient(110deg,#c8fbfb 0%,#dbffff 44%,#f7ffff 100%);color:#5e6b88;padding:19px 28px;display:flex;align-items:center;',
    'justify-content:space-between;flex-shrink:0;border-bottom:1px solid rgba(145,158,171,.16);}',
    '#lhim-window.lhim-chat-mode #lhim-header{background:#eaf2fb;padding:19px 26px;border-bottom:1px solid rgba(92,110,146,.14);}',
    '#lhim-header .lhim-title{font-size:16px;font-weight:600;color:#5e6b88;}',
    '#lhim-header .lhim-subtitle{display:none;}',
    '#lhim-header-actions{display:flex;gap:8px;align-items:center;}',
    '#lhim-header-actions button{background:rgba(255,255,255,.24);border:none;color:#5c6e92;',
    'border-radius:4px;padding:4px 8px;font-size:18px;cursor:pointer;transition:background .2s;}',
    '#lhim-header-actions button:hover{background:rgba(255,255,255,.45);}',
    '#lhim-close-btn{background:none!important;color:#5e6b88;font-size:28px;line-height:1;padding:0!important;font-weight:300;}',
    '#lhim-restart-btn,#lhim-transfer-btn{display:none!important;}',

    /* 状态栏 */
    '#lhim-status{font-size:12px;padding:6px 14px;text-align:center;display:none;}',
    '#lhim-status.lhim-connecting{background:#fff3e0;color:#e65100;}',
    '#lhim-status.lhim-connected{background:#e8f5e9;color:#2e7d32;}',
    '#lhim-status.lhim-error{background:#ffebee;color:#c62828;}',

    /* 游客登录表单 */
    '#lhim-guest-form{padding:24px;display:flex;flex-direction:column;align-items:center;',
    'justify-content:flex-start;flex:1;gap:0;background:radial-gradient(120% 62% at 22% -7%,rgba(186,255,253,.9) 0%,rgba(222,255,255,.72) 34%,rgba(255,255,255,0) 70%),linear-gradient(180deg,#f4ffff 0%,#fff 62%);overflow-y:auto;}',
    '.lhim-guest-icon{width:56px;height:56px;border-radius:18px;background:#fff;box-shadow:0 .875px 7px rgba(0,0,0,.05);',
    'display:flex;align-items:center;justify-content:center;margin-bottom:12px;}',
    '.lhim-guest-icon img{display:block;width:32px;height:34px;}',
    '#lhim-guest-form h3{margin:0;font-size:20px;line-height:30px;color:#1b2438;font-weight:600;text-align:center;font-family:Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;}',
    '#lhim-guest-form h3 span{display:block;color:#00d0dd;background:linear-gradient(198deg,#85f7aa 3%,#00d0dd 94%);-webkit-background-clip:text;background-clip:text;-webkit-text-fill-color:transparent;}',
    '#lhim-guest-form p{margin:8px 0 34px;font-size:14px;line-height:20px;color:#5e6b88;text-align:center;max-width:312px;font-family:Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;}',
    '.lhim-field{width:100%;position:relative;margin-bottom:30px;}',
    '#lhim-guest-form input[type="text"],#lhim-guest-form input[type="email"]{width:100%;height:40px;padding:0 12px;border:1px solid #fff;',
    'border-radius:8px;background:#f5f8fa;box-shadow:inset -2px -4px 6px #fff,inset 2px 4px 8px rgba(173,194,216,.7);',
    'font-size:14px;color:#1b2438;box-sizing:border-box;transition:border-color .2s,box-shadow .2s;background-clip:padding-box;}',
    '#lhim-guest-form input[type="text"]::placeholder,#lhim-guest-form input[type="email"]::placeholder{color:#5e6b88;opacity:1;}',
    '#lhim-guest-form input[type="text"]:focus,#lhim-guest-form input[type="email"]:focus{outline:none;border-color:#9ffff4;box-shadow:inset -2px -4px 6px #fff,inset 2px 4px 8px rgba(173,194,216,.7),0 0 0 3px rgba(0,208,221,.14);}',
    '.lhim-required{color:#ff4f72;}',
    '.lhim-consent{width:100%;display:flex;align-items:flex-start;gap:8px;margin:-12px 0 34px;color:#5e6b88;font-size:14px;line-height:20px;font-family:Poppins,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif;}',
    '.lhim-consent input{appearance:none;-webkit-appearance:none;width:14px;height:14px;min-width:14px;margin:3px 0 0;border:1px solid #00d0dd;border-radius:2px;background:#fff;cursor:pointer;position:relative;}',
    '.lhim-consent input:checked{background:#00d0dd;border-color:#00d0dd;}',
    '.lhim-consent input:checked::after{content:"";position:absolute;left:3px;top:0;width:6px;height:9px;border:solid #fff;border-width:0 2px 2px 0;transform:rotate(45deg);}',
    '.lhim-consent a{color:#00d0dd;text-decoration:none;}',
    '#lhim-guest-start,#lhim-chat-start{width:100%;height:40px;padding:0;background:linear-gradient(198deg,#6ef1e9 3%,#3cc5da 94%);color:#fff;border:1px solid #9ffff4;',
    'border-radius:8px;font-size:14px;font-weight:400;box-sizing:border-box;cursor:pointer;transition:background .2s,box-shadow .2s,opacity .2s;box-shadow:inset 2px 2px 3px #2eadbb;display:flex;align-items:center;justify-content:center;gap:8px;}',
    '#lhim-guest-start:hover:not(:disabled),#lhim-chat-start:hover:not(:disabled){box-shadow:inset 2px 2px 3px #2eadbb,0 4px 12px rgba(0,173,184,.24);}',
    '#lhim-guest-start:disabled,#lhim-chat-start:disabled{background:#eaf4ff;color:#c6d3e3;box-shadow:inset 0 2px 6px rgba(42,68,110,.08);cursor:not-allowed;}',
    '.lhim-start-spinner{width:15px;height:15px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;display:none;}',
    '#lhim-guest-start.lhim-loading .lhim-start-spinner,#lhim-chat-start.lhim-loading .lhim-start-spinner{display:block;animation:lhimSpin .8s linear infinite;}',
    '@keyframes lhimSpin{to{transform:rotate(360deg)}}',
    '.lhim-form-error{color:#e5435d;font-size:12px;display:none;text-align:left;width:100%;margin:-20px 0 12px;}',

    /* 推荐问题 */
    '#lhim-tips{padding:8px 12px;background:#f9f9f9;border-bottom:1px solid #eee;display:none;flex-shrink:0;}',
    '#lhim-tips .lhim-tips-label{font-size:12px;color:#888;margin-bottom:6px;}',
    '#lhim-tips-list{display:flex;flex-wrap:wrap;gap:6px;}',
    '#lhim-tips-list .lhim-tip{padding:5px 10px;background:#fff;border:1px solid #ddd;border-radius:14px;',
    'font-size:12px;cursor:pointer;transition:all .2s;}',
    '#lhim-tips-list .lhim-tip:hover{background:#4a90e2;color:#fff;border-color:#4a90e2;}',

    /* 消息列表 */
    '#lhim-msgs{position:relative;flex:1;overflow-y:auto;padding:16px;background:#eaf2fb;}',
    '#lhim-msgs::-webkit-scrollbar{width:4px;}',
    '#lhim-msgs::-webkit-scrollbar-thumb{background:#ccc;border-radius:2px;}',
    '.lhim-loading-state{height:100%;min-height:240px;display:flex;flex-direction:column;align-items:center;justify-content:center;color:#5e6b88;font-size:14px;gap:12px;}',
    '.lhim-loading-state .lhim-loading-spinner{width:28px;height:28px;border:3px solid rgba(0,208,221,.22);border-right-color:#00d0dd;border-radius:50%;animation:lhimSpin .8s linear infinite;}',

    /* 消息气泡 */
    '.lhim-msg{display:flex;margin-bottom:12px;animation:lhimFadeIn .25s ease;}',
    '@keyframes lhimFadeIn{from{opacity:0;transform:translateY(8px)}to{opacity:1;transform:translateY(0)}}',
    '.lhim-msg.lhim-self{flex-direction:row-reverse;}',
    '.lhim-avatar{width:38px;height:38px;border-radius:50%;background:#fff;color:#10c7c9;',
    'font-size:0;font-weight:600;display:flex;align-items:center;justify-content:center;flex-shrink:0;box-shadow:0 7px 18px rgba(27,158,168,.1);}',
    '.lhim-avatar::before{content:"";width:18px;height:20px;background:no-repeat center/contain url("' + LHIM_AI_AVATAR_DATA_URI + '");}',
    '.lhim-avatar.lhim-human-avatar{background:#eef3f8;box-shadow:none;}',
    '.lhim-avatar.lhim-human-avatar::before{width:15px;height:16px;background:no-repeat center/contain url("data:image/svg+xml,%3Csvg width=\'15\' height=\'16\' viewBox=\'0 0 15 16\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M7.48586 8.75C11.4757 8.75 14.7543 10.6611 14.9986 14.75C15.0083 14.9129 14.9983 15.4168 14.3726 15.417H0.605978C0.397037 15.4166 -0.016497 14.9667 0.000508785 14.75C0.323507 10.7728 3.55145 8.75009 7.48586 8.75ZM7.49953 0C9.57052 0 11.2494 1.67904 11.2495 3.75C11.2495 5.82107 9.5706 7.5 7.49953 7.5C5.42868 7.49975 3.74953 5.82091 3.74953 3.75C3.74966 1.67919 5.42876 0.00025147 7.49953 0Z\' fill=\'%235E6B88\'/%3E%3C/svg%3E");}',
    '.lhim-bubble-wrap{max-width:82%;margin:0 12px;}',
    '.lhim-sender{font-size:14px;color:#5c6e92;margin:4px 0 12px;}',
    '.lhim-msg.lhim-self .lhim-sender{text-align:right;}',
    '.lhim-msg.lhim-self .lhim-bubble-wrap{margin-right:0;}',
    '.lhim-bubble{padding:14px 14px;border-radius:8px;background:#fff;',
    'box-shadow:none;font-size:14px;line-height:1.26;color:#1d263d;word-break:break-word;}',
    '.lhim-msg.lhim-self .lhim-bubble{background:#00D0DD;color:##1B2438;}',
    '.lhim-msg.lhim-pending{opacity:.72;}',
    '.lhim-msg.lhim-failed .lhim-bubble{background:#ffebee;color:#c62828;}',
    '.lhim-msg.lhim-system .lhim-bubble{background:#fff3e0;color:#e65100;text-align:center;font-size:12px;}',
    '.lhim-new-divider{display:flex;align-items:center;gap:10px;margin:18px 0;color:#8a99b4;font-size:12px;line-height:1;}',
    '.lhim-new-divider::before,.lhim-new-divider::after{content:"";height:1px;background:#d7e3f0;flex:1;}',
    '.lhim-new-divider span{white-space:nowrap;}',
    '.lhim-bubble p{margin:0 0 8px;}',
    '.lhim-bubble p:last-child,.lhim-bubble ul:last-child,.lhim-bubble ol:last-child,.lhim-bubble pre:last-child,.lhim-bubble blockquote:last-child{margin-bottom:0;}',
    '.lhim-bubble ul,.lhim-bubble ol{margin:0 0 8px 18px;padding:0;}',
    '.lhim-bubble li{margin:2px 0;}',
    '.lhim-bubble blockquote{margin:0 0 8px;padding:0 0 0 10px;border-left:3px solid rgba(0,0,0,.18);color:#666;}',
    '.lhim-bubble h4,.lhim-bubble h5,.lhim-bubble h6{margin:0 0 8px;font-size:14px;line-height:1.4;font-weight:700;}',
    '.lhim-bubble pre{margin:0 0 8px;padding:8px 10px;overflow-x:auto;background:#f5f7fa;border-radius:6px;font-size:12px;line-height:1.45;}',
    '.lhim-bubble code{font-family:ui-monospace,SFMono-Regular,Menlo,Consolas,monospace;background:#f2f3f5;border-radius:4px;padding:1px 4px;font-size:.92em;}',
    '.lhim-bubble pre code{background:transparent;border-radius:0;padding:0;font-size:inherit;}',
    '.lhim-attachment-media{display:block;max-width:230px;max-height:180px;border-radius:8px;object-fit:cover;}',
    '.lhim-attachment-video{display:block;width:230px;max-width:100%;border-radius:8px;background:#000;}',
    '.lhim-attachment-file{display:flex;align-items:center;gap:8px;color:inherit;text-decoration:none;font-weight:500;}',
    '.lhim-attachment-file::before{content:"";width:18px;height:18px;flex:0 0 auto;background:currentColor;mask:url("data:image/svg+xml,%3Csvg width=\'18\' height=\'18\' viewBox=\'0 0 18 18\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M5.25 2.25h5.1L14.25 6.15v9.6h-9V2.25Z\' stroke=\'black\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/%3E%3Cpath d=\'M10.125 2.625V6.75h4.125\' stroke=\'black\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/contain no-repeat;-webkit-mask:url("data:image/svg+xml,%3Csvg width=\'18\' height=\'18\' viewBox=\'0 0 18 18\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M5.25 2.25h5.1L14.25 6.15v9.6h-9V2.25Z\' stroke=\'black\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/%3E%3Cpath d=\'M10.125 2.625V6.75h4.125\' stroke=\'black\' stroke-width=\'1.5\' stroke-linejoin=\'round\'/%3E%3C/svg%3E") center/contain no-repeat;}',
    '.lhim-bubble a{color:#2563eb;text-decoration:underline;text-underline-offset:2px;}',
    '.lhim-msg.lhim-self .lhim-bubble code{background:rgba(255,255,255,.18);}',
    '.lhim-msg.lhim-self .lhim-bubble a{color:#fff;}',
    '.lhim-time{font-size:11px;color:#bbb;margin-top:3px;}',
    '.lhim-send-state{font-size:11px;color:#8a99b4;margin-top:3px;text-align:right;}',
    '.lhim-msg.lhim-failed .lhim-send-state{color:#c62828;}',
    '.lhim-msg.lhim-self .lhim-time{text-align:right;}',

    /* 空状态 */
    '.lhim-empty{display:flex;flex-direction:column;align-items:center;justify-content:center;',
    'height:100%;color:#ccc;font-size:13px;}',
    '.lhim-empty-icon{font-size:40px;margin-bottom:10px;}',

    /* 输入区 */
    '#lhim-input-area{position:relative;padding:12px 16px 16px;border-top:1px solid rgba(92,110,146,.1);background:rgba(255,255,255,.76);flex-shrink:0;border-radius:12px 12px 0 0;}',
    '#lhim-action-tabs{display:flex;align-items:center;gap:10px;margin-bottom:14px;}',
    '.lhim-action-tab{height:37px;padding:0 12px;border:0;border-radius:5px;background:#fff;color:#1d263d;box-shadow:0 4px 12px rgba(41,68,106,.18);font-size:14px;font-family:inherit;display:flex;align-items:center;gap:6px;cursor:pointer;transition:background .18s,color .18s,box-shadow .18s;}',
    '.lhim-action-tab:hover,.lhim-action-tab:focus-visible,.lhim-more-wrap.lhim-more-open .lhim-action-tab{background:#f3f8ff;color:#00c8d7;box-shadow:0 5px 14px rgba(41,68,106,.22);outline:none;}',
    '.lhim-tab-icon{width:16px;height:16px;display:inline-flex;align-items:center;justify-content:center;}',
    '.lhim-tab-icon svg,.lhim-tab-icon img{width:16px;height:16px;display:block;}',
    '.lhim-more-wrap{position:relative;}',
    '.lhim-more-menu{position:absolute;right:-30px;bottom:46px;width:319px;padding:10px 0;background:#fff;border:1px solid rgba(92,110,146,.16);border-radius:5px;box-shadow:0 4px 16px rgba(41,68,106,.18);display:none;z-index:2;}',
    '.lhim-more-wrap.lhim-more-open .lhim-more-menu,.lhim-more-wrap:focus-within .lhim-more-menu{display:block;}',
    '.lhim-more-menu::after{content:"";position:absolute;right:27px;bottom:-9px;width:17px;height:17px;background:#fff;border-right:1px solid rgba(92,110,146,.16);border-bottom:1px solid rgba(92,110,146,.16);transform:rotate(45deg);}',
    '.lhim-more-item{height:37px;width:100%;padding:0 12px;border:0;background:#fff;color:#1d263d;font-size:14px;font-family:inherit;text-align:left;display:flex;align-items:center;gap:9px;cursor:pointer;}',
    '.lhim-more-item img{width:16px;height:16px;display:block;flex:0 0 auto;}',
    '.lhim-more-item:hover,.lhim-more-item:focus-visible{background:#eaf2fb;outline:none;}',
    '#lhim-input-row{position:relative;display:block;}',
    '#lhim-input{width:100%;min-height:40px;max-height:100px;padding:12px 46px 12px 12px;border:1px solid rgba(116,146,190,.16);background:#f7fbff;',
    'border-radius:7px;resize:none;font-size:16px;font-family:inherit;line-height:1.25;box-shadow:inset 0 4px 9px rgba(42,68,110,.13);box-sizing:border-box;}',
    '#lhim-input::placeholder{color:#8a99b4;opacity:1;}',
    '#lhim-input:focus{outline:none;border-color:#31cfd0;box-shadow:inset 0 3px 8px rgba(42,68,110,.13),0 0 0 3px rgba(49,207,208,.16);}',
    '#lhim-attachment{position:absolute;right:9px;top:46%;width:28px;height:28px;padding:0;border:0;background:transparent;color:#5e6b88;',
    'display:none;align-items:center;justify-content:center;transform:translateY(-50%);cursor:pointer;border-radius:6px;}',
    '#lhim-attachment:hover,#lhim-attachment:focus-visible{background:#eaf2fb;color:#00c8d7;outline:none;}',
    '#lhim-attachment img{width:16px;height:16px;display:block;}',
    '#lhim-cancel-order{display:none;}',
    '#lhim-send{display:none;}',
    '#lhim-send:disabled{background:#ccc;cursor:not-allowed;}',
    '#lhim-chat-start{display:none;}',
    '#lhim-input-row.lhim-session-ended #lhim-input,#lhim-input-row.lhim-session-ended #lhim-attachment,#lhim-input-row.lhim-session-ended #lhim-send{display:none;}',
    '#lhim-input-row.lhim-session-ended #lhim-chat-start{display:flex;}',
    '#lhim-input-area.lhim-session-ended #lhim-action-tabs{display:none;}',

    /* 流式输出光标 */
    '.lhim-bubble.lhim-streaming::after{content:"";display:inline-block;width:2px;height:1em;',
    'background:currentColor;margin-left:2px;vertical-align:text-bottom;opacity:.85;',
    'animation:lhimCursorBlink 1s step-end infinite;}',
    '.lhim-bubble.lhim-typing-bubble::after{display:none;}',
    '.lhim-typing-dots{display:inline-flex;align-items:center;gap:4px;min-width:28px;vertical-align:middle;}',
    '.lhim-typing-dots span{width:5px;height:5px;border-radius:50%;background:#5e6b88;opacity:.38;animation:lhimTypingDots 1.1s ease-in-out infinite;}',
    '.lhim-typing-dots span:nth-child(2){animation-delay:.16s;}',
    '.lhim-typing-dots span:nth-child(3){animation-delay:.32s;}',
    '@keyframes lhimCursorBlink{50%{opacity:0;}}',
    '@keyframes lhimTypingDots{0%,80%,100%{transform:translateY(0);opacity:.38;}40%{transform:translateY(-3px);opacity:1;}}',

    /* 响应式：小屏全屏 */
    '@media(max-width:520px){#lhim-window{width:calc(100vw - 28px);max-height:calc(100vh - 28px);bottom:14px;right:14px;border-radius:10px;}',
    '#lhim-header{padding:20px 22px;}#lhim-header .lhim-title{font-size:16px;}#lhim-guest-form{padding:24px 22px 28px;}',
    '.lhim-guest-icon{width:68px;height:68px;margin-bottom:22px;}#lhim-guest-form h3{font-size:19px;}#lhim-guest-form p{font-size:14px;margin:12px 0 32px;}',
    '.lhim-field{margin-bottom:28px;}.lhim-consent{font-size:14px;margin:-10px 0 30px;}#lhim-trigger{bottom:16px;right:16px;}}'
  ].join('');

  function injectStyle() {
    var el = document.createElement('style');
    el.id = 'lhim-style';
    el.textContent = STYLE;
    document.head.appendChild(el);
  }

  // ─── 构建 DOM ────────────────────────────────────────────────────────────────
  function buildDOM() {
    // 触发按钮
    var trigger = document.createElement('button');
    trigger.id = 'lhim-trigger';
    trigger.setAttribute('aria-label', 'Contact Support');
    trigger.innerHTML = '<span class="lhim-trigger-icon" aria-hidden="true"><svg viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg"><defs><radialGradient id="lhim-trigger-gradient" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(20 17) rotate(52) scale(38)"><stop stop-color="#56F2F2"/><stop offset=".48" stop-color="#16D9DF"/><stop offset="1" stop-color="#00C8D7"/></radialGradient></defs><circle cx="28" cy="28" r="24" fill="url(#lhim-trigger-gradient)"/><g transform="translate(12 14)"><path d="M15.9672 0C22.0605 5.1242e-05 27.2743 3.63854 29.04 8.71026C31.4075 9.42968 32.9011 12.4064 31.3916 16.0425C30.711 17.6816 28.509 19.3354 27.7909 18.8346C27.6915 18.9884 27.5905 19.1413 27.4842 19.2907L27.4833 19.2897C26.3505 20.9493 22.9071 24.3427 17.603 25.7548C17.4999 26.7394 16.8074 27.5009 15.9663 27.5009C15.0541 27.5009 14.3148 26.6055 14.3148 25.5009C14.3148 24.3963 15.0541 23.5008 15.9663 23.5008C16.6587 23.5008 17.2501 24.0172 17.4956 24.7489C22.4595 23.381 25.6612 20.192 26.6629 18.7194L26.6688 18.7106C27.8242 17.0852 28.5343 15.1829 28.6581 13.1401C28.6783 11.9544 28.4958 10.4825 27.9393 8.6292C26.1875 4.2013 21.5162 1.00008 15.9672 1.00003C10.4533 1.00007 5.80474 4.16066 4.02738 8.54522C4.04647 8.54494 4.06584 8.54327 4.085 8.54326C1.66242 16.4994 6.06685 17.5006 4.21488 18.8317C3.50211 19.344 1.29046 17.6855 0.608313 16.0425C-0.885044 12.4453 0.561254 9.494 2.88476 8.73468C4.64203 3.65004 9.86403 3.68846e-05 15.9672 0Z" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M15.9672 3.50012C21.4401 3.50051 25.8768 7.52994 25.8768 12.5004C25.8768 17.4709 21.4401 21.5004 15.9672 21.5007C15.3465 21.5007 14.7389 21.4456 14.1498 21.3464L7.32534 24.6532C7.07617 24.7735 6.81112 24.5204 6.91908 24.2655L9.13986 19.0212C7.24159 17.3815 6.05674 15.0674 6.05674 12.5004C6.05674 7.5297 10.494 3.50012 15.9672 3.50012ZM11.5618 10.5004C10.8016 10.5004 10.1848 11.3958 10.1848 12.5004C10.1848 13.605 10.8016 14.5005 11.5618 14.5005C12.3217 14.5 12.9378 13.6047 12.9378 12.5004C12.9378 11.3961 12.3217 10.5009 11.5618 10.5004ZM15.9663 10.5004C15.2061 10.5004 14.5893 11.3958 14.5893 12.5004C14.5893 13.605 15.2061 14.5005 15.9663 14.5005C16.7262 14.5 17.3423 13.6048 17.3423 12.5004C17.3423 11.3961 16.7262 10.5008 15.9663 10.5004ZM20.3707 10.5004C19.6105 10.5004 18.9937 11.3958 18.9937 12.5004C18.9937 13.605 19.6105 14.5005 20.3707 14.5005C21.1307 14.5001 21.7467 13.6048 21.7467 12.5004C21.7467 11.3961 21.1307 10.5008 20.3707 10.5004Z" fill="white"/></g></svg></span><span class="lhim-badge" id="lhim-badge"></span>';
    trigger.addEventListener('click', toggleWindow);
    document.body.appendChild(trigger);

    // 聊天窗口
    var win = document.createElement('div');
    win.id = 'lhim-window';
    win.setAttribute('role', 'dialog');
    win.setAttribute('aria-label', 'Customer Support Chat');
    win.innerHTML = [
      /* 头部 */
      '<div id="lhim-header">',
      '  <div>',
      '    <div class="lhim-title">Sigenergy Support</div>',
      '    <div class="lhim-subtitle" id="lhim-subtitle">How can we help you?</div>',
      '  </div>',
      '  <div id="lhim-header-actions">',
      '    <button id="lhim-restart-btn" title="New Conversation">&#x1F504;</button>',
      '    <button id="lhim-transfer-btn" title="Transfer to Agent">&#x1F464;</button>',
      '    <button id="lhim-close-btn" aria-label="Close">&#x2715;</button>',
      '  </div>',
      '</div>',
      /* 状态栏 */
      '<div id="lhim-status"></div>',
      /* 游客表单（默认隐藏） */
      '<div id="lhim-guest-form" style="display:none;">',
      '  <div class="lhim-guest-icon" aria-hidden="true">',
      '    <img src="' + LHIM_GUEST_LOGO_DATA_URI + '" alt="" />',
      '  </div>',
      '  <h3>' + escapeHtml(GUEST_FORM_TITLE_PREFIX) + ' <span>' + escapeHtml(GUEST_FORM_TITLE_BRAND) + '</span></h3>',
      '  <p>' + escapeHtml(GUEST_FORM_DESCRIPTION) + '</p>',
      '  <div class="lhim-field"><input type="email" id="lhim-guest-email" placeholder="' + escapeAttr(GUEST_EMAIL_PLACEHOLDER) + '" autocomplete="email" /></div>',
      '  <div class="lhim-field"><input type="text" id="lhim-guest-name" placeholder="' + escapeAttr(GUEST_NAME_PLACEHOLDER) + '" autocomplete="name" /></div>',
      '  <div class="lhim-form-error" id="lhim-form-error"></div>',
      '  <label class="lhim-consent" for="lhim-guest-consent">',
      '    <input type="checkbox" id="lhim-guest-consent" />',
      '    <span>' + escapeHtml(GUEST_CONSENT_PREFIX) + ' <a href="' + escapeAttr(getStoreUrl(PRIVACY_POLICY_URLS)) + '" target="_blank" rel="noopener noreferrer">' + escapeHtml(GUEST_PRIVACY_POLICY_LABEL) + '</a>.</span>',
      '  </label>',
      '  <button id="lhim-guest-start" disabled><span class="lhim-start-spinner" aria-hidden="true"></span><span>' + escapeHtml(GUEST_START_LABEL) + '</span></button>',
      '</div>',
      /* 推荐问题 */
      '<div id="lhim-tips">',
      '  <div class="lhim-tips-label">Suggested Questions (click to send)</div>',
      '  <div id="lhim-tips-list"></div>',
      '</div>',
      /* 消息列表 */
      '<div id="lhim-msgs">',
      '  <div class="lhim-empty"><div class="lhim-empty-icon">&#x2709;&#xFE0F;</div><div>No messages yet. Start a conversation!</div></div>',
      '</div>',
      /* 输入区 */
      '<div id="lhim-input-area">',
      '  <div id="lhim-action-tabs">',
      '    <button class="lhim-action-tab" id="lhim-more-faq" type="button">',
      '      <span class="lhim-tab-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.1466 7.9989C14.1465 6.36867 13.4988 4.80525 12.3459 3.65257C11.1931 2.4999 9.62962 1.85239 7.99939 1.8525C6.36916 1.85261 4.80574 2.50032 3.65306 3.65314C2.50039 4.80596 1.85288 6.36947 1.85299 7.9997C1.85299 9.62993 2.5006 11.1934 3.65334 12.3461C4.80609 13.4989 6.36956 14.1465 7.99979 14.1465C9.63002 14.1465 11.1935 13.4989 12.3462 12.3461C13.499 11.1934 14.1466 9.62993 14.1466 7.9997V7.9989ZM7.48019 11.3325V10.6661C7.48019 10.5978 7.49364 10.5302 7.51977 10.4671C7.5459 10.404 7.58421 10.3467 7.63249 10.2984C7.68078 10.2501 7.7381 10.2118 7.80119 10.1857C7.86428 10.1595 7.9319 10.1461 8.00019 10.1461C8.06848 10.1461 8.13609 10.1595 8.19918 10.1857C8.26227 10.2118 8.3196 10.2501 8.36788 10.2984C8.41617 10.3467 8.45447 10.404 8.48061 10.4671C8.50674 10.5302 8.52019 10.5978 8.52019 10.6661V11.3325C8.52019 11.4704 8.4654 11.6027 8.36788 11.7002C8.27037 11.7977 8.1381 11.8525 8.00019 11.8525C7.86228 11.8525 7.73001 11.7977 7.63249 11.7002C7.53497 11.6027 7.48019 11.4704 7.48019 11.3325ZM7.48019 8.9989V8.6661C7.48019 8.1269 7.74419 7.6813 7.99059 7.3429C8.11619 7.1709 8.25459 7.0021 8.37299 6.8549C8.49619 6.7021 8.60099 6.5669 8.68499 6.4381C8.75324 6.3317 8.79577 6.21087 8.80919 6.08517C8.82261 5.95948 8.80656 5.83239 8.76231 5.71398C8.71806 5.59557 8.64682 5.4891 8.55426 5.40301C8.46169 5.31693 8.35034 5.25359 8.22904 5.21804C8.10773 5.18248 7.97981 5.17568 7.85542 5.19817C7.73103 5.22066 7.61359 5.27183 7.51242 5.34762C7.41125 5.4234 7.32912 5.52172 7.27257 5.63477C7.21601 5.74782 7.18657 5.87249 7.18659 5.9989C7.18659 6.13681 7.1318 6.26908 7.03428 6.3666C6.93677 6.46411 6.8045 6.5189 6.66659 6.5189C6.52868 6.5189 6.39641 6.46411 6.29889 6.3666C6.20137 6.26908 6.14659 6.13681 6.14659 5.9989C6.1464 5.71073 6.2134 5.42649 6.34228 5.16874C6.47115 4.91099 6.65835 4.68684 6.88899 4.51409C7.11964 4.34134 7.38739 4.22474 7.67098 4.17356C7.95457 4.12238 8.24618 4.13803 8.52267 4.21926C8.79915 4.30048 9.05289 4.44506 9.26373 4.64149C9.47458 4.83793 9.63671 5.08082 9.73727 5.35088C9.83783 5.62093 9.87404 5.91071 9.84302 6.19721C9.812 6.48371 9.71461 6.75902 9.55859 7.0013C9.44246 7.17654 9.31722 7.34557 9.18339 7.5077C9.05379 7.6685 8.93699 7.8101 8.83139 7.9557C8.61619 8.2509 8.51939 8.4693 8.51939 8.6661V8.9989C8.51939 9.13681 8.4646 9.26908 8.36708 9.3666C8.26957 9.46411 8.1373 9.5189 7.99939 9.5189C7.86148 9.5189 7.72921 9.46411 7.63169 9.3666C7.53417 9.26908 7.47939 9.13681 7.47939 8.9989H7.48019ZM15.1858 7.9989C15.1858 8.94263 14.9999 9.87712 14.6388 10.749C14.2776 11.6209 13.7483 12.4131 13.0809 13.0805C12.4136 13.7478 11.6214 14.2771 10.7495 14.6383C9.87761 14.9994 8.94312 15.1853 7.99939 15.1853C7.05566 15.1853 6.12117 14.9994 5.24927 14.6383C4.37738 14.2771 3.58516 13.7478 2.91784 13.0805C2.25052 12.4131 1.72117 11.6209 1.36002 10.749C0.99887 9.87712 0.812988 8.94263 0.812988 7.9989C0.812988 6.09295 1.57012 4.26506 2.91784 2.91735C4.26555 1.56964 6.09344 0.8125 7.99939 0.8125C9.90534 0.8125 11.7332 1.56964 13.0809 2.91735C14.4287 4.26506 15.1858 6.09295 15.1858 7.9989Z" fill="currentColor"/></svg></span>',
      '      <span>' + escapeHtml(FAQS_LABEL) + '</span>',
      '    </button>',
      '    <button class="lhim-action-tab" id="lhim-contact-tab" type="button">',
      '      <span class="lhim-tab-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.52319 2.6642C4.47596 2.60345 4.41635 2.55344 4.34831 2.5175C4.28027 2.48156 4.20536 2.4605 4.12856 2.45574C4.05176 2.45097 3.97482 2.4626 3.90286 2.48985C3.8309 2.5171 3.76556 2.55935 3.71119 2.6138L2.88399 3.4418C2.49759 3.829 2.35519 4.377 2.52399 4.8578C3.22458 6.84787 4.36422 8.65468 5.85839 10.1442C7.34793 11.6383 9.15473 12.778 11.1448 13.4786C11.6256 13.6474 12.1736 13.505 12.5608 13.1186L13.388 12.2914C13.4424 12.237 13.4847 12.1717 13.5119 12.0997C13.5392 12.0278 13.5508 11.9508 13.546 11.874C13.5413 11.7972 13.5202 11.7223 13.4843 11.6543C13.4483 11.5862 13.3983 11.5266 13.3376 11.4794L11.492 10.0442C11.4271 9.99386 11.3516 9.95892 11.2712 9.94201C11.1908 9.9251 11.1077 9.92667 11.028 9.9466L9.27599 10.3842C9.04213 10.4426 8.79712 10.4395 8.56482 10.3752C8.33252 10.3108 8.12084 10.1874 7.95039 10.017L5.98559 8.0514C5.815 7.88103 5.69145 7.66938 5.62696 7.43708C5.56247 7.20477 5.55924 6.95972 5.61759 6.7258L6.05599 4.9738C6.07591 4.89412 6.07748 4.81095 6.06057 4.73057C6.04367 4.65019 6.00872 4.5747 5.95839 4.5098L4.52319 2.6642ZM3.10719 2.0106C3.24718 1.87056 3.41537 1.7619 3.60058 1.69185C3.78579 1.62179 3.98378 1.59194 4.18141 1.60427C4.37904 1.61661 4.57179 1.67084 4.74685 1.76338C4.92191 1.85592 5.07529 1.98464 5.19679 2.141L6.63199 3.9858C6.89519 4.3242 6.98799 4.765 6.88399 5.181L6.44639 6.933C6.42376 7.02374 6.42498 7.11879 6.44993 7.20893C6.47488 7.29906 6.52272 7.38121 6.58879 7.4474L8.55439 9.413C8.62066 9.4792 8.70294 9.52711 8.79323 9.55207C8.88351 9.57702 8.97872 9.57817 9.06959 9.5554L10.8208 9.1178C11.0261 9.06647 11.2404 9.06248 11.4474 9.10614C11.6545 9.1498 11.8489 9.23995 12.016 9.3698L13.8608 10.805C14.524 11.321 14.5848 12.301 13.9912 12.8938L13.164 13.721C12.572 14.313 11.6872 14.573 10.8624 14.2826C8.75133 13.5398 6.8346 12.3313 5.25439 10.7466C3.66982 9.16661 2.46127 7.25017 1.71839 5.1394C1.42879 4.3154 1.68879 3.4298 2.28079 2.8378L3.10799 2.0106H3.10719ZM11.7168 2.1186C11.7539 2.08135 11.7981 2.05179 11.8467 2.03163C11.8953 2.01146 11.9474 2.00108 12 2.00108C12.0526 2.00108 12.1047 2.01146 12.1533 2.03163C12.2019 2.05179 12.246 2.08135 12.2832 2.1186L14.2832 4.1186C14.3204 4.15576 14.35 4.1999 14.3702 4.24849C14.3903 4.29709 14.4007 4.34918 14.4007 4.4018C14.4007 4.45441 14.3903 4.50651 14.3702 4.55511C14.35 4.6037 14.3204 4.64784 14.2832 4.685L12.2832 6.685C12.2081 6.76011 12.1062 6.8023 12 6.8023C11.8938 6.8023 11.7919 6.76011 11.7168 6.685C11.6417 6.60989 11.5995 6.50802 11.5995 6.4018C11.5995 6.29558 11.6417 6.19371 11.7168 6.1186L13.0344 4.8018H9.19999C9.0939 4.8018 8.99216 4.75966 8.91714 4.68464C8.84213 4.60963 8.79999 4.50788 8.79999 4.4018C8.79999 4.29571 8.84213 4.19397 8.91714 4.11896C8.99216 4.04394 9.0939 4.0018 9.19999 4.0018H13.0344L11.7168 2.685C11.6795 2.64784 11.65 2.6037 11.6298 2.55511C11.6097 2.50651 11.5993 2.45441 11.5993 2.4018C11.5993 2.34918 11.6097 2.29709 11.6298 2.24849C11.65 2.1999 11.6795 2.15576 11.7168 2.1186Z" fill="currentColor"/></svg></span>',
      '      <span>' + escapeHtml(CONTACT_US_LABEL) + '</span>',
      '    </button>',
    
      '    <div class="lhim-more-wrap">',
      '      <button class="lhim-action-tab" id="lhim-more-tab" type="button" aria-haspopup="true">',
      '        <span class="lhim-tab-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.33301 8.66699V14H2V8.66699H7.33301ZM14 8.66699V14H8.66699V8.66699H14ZM9.66699 13H13V9.66699H9.66699V13ZM3 13H6.33301V9.66699H3V13ZM7.33301 2V7.33301H2V2H7.33301ZM14 2V7.33301H8.66699V2H14ZM9.66699 6.33301H13V3H9.66699V6.33301ZM3 6.33301H6.33301V3H3V6.33301Z" fill="currentColor"/></svg></span>',
      '        <span>' + escapeHtml(MORE_LABEL) + '</span>',
      '      </button>',
      '      <div class="lhim-more-menu" role="menu">',
      '        <button class="lhim-more-item" id="lhim-more-human" type="button" role="menuitem" style="display:none;"><img src="' + LHIM_SERVICE_ICON_DATA_URI + '" alt="" aria-hidden="true" width="16" height="16" /><span>' + escapeHtml(HUMAN_AGENT_LABEL) + '</span></button>',
      '        <button class="lhim-more-item" id="lhim-restart-tab" type="button" role="menuitem">',
      '          <span class="lhim-tab-icon" aria-hidden="true"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5566 5.19802C13.5566 4.63069 13.5566 4.23136 13.53 3.92069C13.5053 3.61402 13.4586 3.43202 13.3866 3.29069C13.2373 2.99818 12.9993 2.7604 12.7066 2.61136C12.5666 2.53936 12.3833 2.49269 12.0773 2.46736C11.766 2.44202 11.3673 2.44136 10.8 2.44136H5.20064C4.63331 2.44136 4.23397 2.44202 3.92331 2.46802C3.61664 2.49269 3.43464 2.53936 3.29331 2.61136C3.00131 2.76069 2.76331 2.99802 2.61397 3.29136C2.54197 3.43202 2.49531 3.61469 2.46997 3.92069C2.44464 4.23202 2.44397 4.63069 2.44397 5.19802V8.99802C2.44397 9.47002 2.44397 9.80202 2.46197 10.0627C2.47997 10.3187 2.51264 10.4727 2.56197 10.594C2.72012 10.9753 3.02322 11.2782 3.40464 11.436C3.52597 11.486 3.67997 11.5187 3.93597 11.536C4.19597 11.554 4.52864 11.5547 5.00064 11.5547C5.30531 11.5547 5.52931 11.552 5.74197 11.602C6.01064 11.6654 6.26064 11.7907 6.47264 11.9674C6.64064 12.1074 6.77264 12.2887 6.95531 12.532L7.92864 13.83L8.00064 13.9254L8.07264 13.83L9.04597 12.532C9.22864 12.2887 9.36064 12.1074 9.52864 11.9674C9.74054 11.7905 9.9907 11.6654 10.2593 11.602C10.4726 11.552 10.696 11.5547 11.0006 11.5547C11.4726 11.5547 11.8046 11.5547 12.0653 11.5367C12.3213 11.5187 12.476 11.486 12.5966 11.4367C12.9779 11.2785 13.2808 10.9754 13.4386 10.594C13.4886 10.4727 13.5213 10.3187 13.5386 10.0627C13.5566 9.80269 13.5573 9.47002 13.5573 8.99802V5.19802H13.5566ZM7.55664 8.99802V7.44136H5.99997C5.88239 7.44136 5.76963 7.39465 5.68649 7.31151C5.60335 7.22837 5.55664 7.1156 5.55664 6.99802C5.55664 6.88044 5.60335 6.76768 5.68649 6.68454C5.76963 6.6014 5.88239 6.55469 5.99997 6.55469H7.55664V4.99802C7.55664 4.88044 7.60335 4.76768 7.68649 4.68454C7.76963 4.6014 7.88239 4.55469 7.99997 4.55469C8.11755 4.55469 8.23032 4.6014 8.31346 4.68454C8.3966 4.76768 8.44331 4.88044 8.44331 4.99802V6.55469H10.0006C10.1102 6.55497 10.2159 6.59585 10.2971 6.66943C10.3783 6.74301 10.4294 6.84407 10.4405 6.95311C10.4516 7.06215 10.422 7.17144 10.3572 7.25989C10.2925 7.34833 10.1973 7.40965 10.09 7.43202L10.0006 7.44136H8.44397V8.99869C8.44397 9.11627 8.39727 9.22903 8.31413 9.31217C8.23098 9.39532 8.11822 9.44202 8.00064 9.44202C7.88306 9.44202 7.7703 9.39532 7.68716 9.31217C7.60402 9.22903 7.55731 9.11627 7.55731 8.99869L7.55664 8.99802ZM14.4433 8.99802C14.4433 9.45802 14.4433 9.82469 14.4233 10.122C14.4026 10.424 14.3593 10.686 14.2566 10.9327C14.1339 11.2292 13.954 11.4986 13.7272 11.7255C13.5004 11.9524 13.2311 12.1325 12.9346 12.2554C12.688 12.3574 12.426 12.4007 12.1246 12.4214C11.8266 12.4414 11.46 12.4414 11 12.4414C10.6533 12.4414 10.5513 12.4447 10.462 12.4654C10.328 12.4974 10.202 12.5587 10.0966 12.648C10.026 12.7067 9.96331 12.786 9.75464 13.064L8.78131 14.362C8.71397 14.452 8.64531 14.5434 8.58197 14.614C8.51664 14.6867 8.42064 14.7787 8.28131 14.8327C8.10036 14.9031 7.89959 14.9031 7.71864 14.8327C7.60251 14.7846 7.49946 14.7097 7.41797 14.614C7.35464 14.5434 7.28597 14.452 7.21864 14.362L6.24531 13.064C6.03731 12.786 5.97397 12.7067 5.90331 12.648C5.79734 12.5596 5.67227 12.4971 5.53797 12.4654C5.44864 12.4447 5.34731 12.4414 4.99997 12.4414C4.53997 12.4414 4.17331 12.4414 3.87597 12.4214C3.57397 12.4007 3.31197 12.3574 3.06531 12.2547C2.76883 12.132 2.49944 11.9521 2.27249 11.7252C2.04555 11.4984 1.8655 11.2291 1.74264 10.9327C1.64064 10.686 1.59731 10.424 1.57664 10.122C1.55664 9.82469 1.55664 9.45802 1.55664 8.99802V5.19802C1.55664 4.64469 1.55664 4.20402 1.58531 3.84802C1.61464 3.48802 1.67664 3.17536 1.82264 2.88869C2.05731 2.42869 2.43064 2.05536 2.89064 1.82069C3.17731 1.67469 3.48931 1.61269 3.85064 1.58336C4.20597 1.55402 4.64731 1.55469 5.19997 1.55469H10.8C11.3533 1.55469 11.794 1.55469 12.15 1.58336C12.5106 1.61269 12.8226 1.67469 13.11 1.82069C13.5693 2.05536 13.9433 2.42869 14.1766 2.88869C14.3233 3.17536 14.3853 3.48736 14.4146 3.84869C14.444 4.20402 14.4433 4.64536 14.4433 5.19802V8.99802Z" fill="currentColor"/></svg></span>',
      '          <span>' + escapeHtml(RESTART_LABEL) + '</span>',
      '        </button>',
      
      '        <button class="lhim-more-item" id="lhim-cancel-order" type="button" role="menuitem"><img src="' + LHIM_CANCEL_ICON_DATA_URI + '" alt="" aria-hidden="true" width="16" height="16" /><span>' + escapeHtml(CANCEL_ORDER_LABEL) + '</span></button>',
      '      </div>',
      '    </div>',
      '  </div>',
      '  <input id="lhim-attachment-input" type="file" accept="image/*,video/*,*/*" multiple hidden />',
      '  <div id="lhim-input-row">',
      '    <textarea id="lhim-input" placeholder="' + escapeAttr(MESSAGE_INPUT_PLACEHOLDER) + '" rows="1"></textarea>',
      '    <button id="lhim-attachment" type="button" aria-label="' + escapeAttr(ADD_ATTACHMENT_LABEL) + '"><img src="' + LHIM_ATTACHMENT_ICON_DATA_URI + '" alt="" aria-hidden="true" width="16" height="16" /></button>',
      '    <button id="lhim-send">' + escapeHtml(SEND_LABEL) + '</button>',
      '    <button id="lhim-chat-start" type="button"><span class="lhim-start-spinner" aria-hidden="true"></span><span>' + escapeHtml(CHAT_START_LABEL) + '</span></button>',
      '  </div>',
      '</div>'
    ].join('');
    document.body.appendChild(win);

    // 事件绑定
    document.getElementById('lhim-close-btn').addEventListener('click', closeWindow);
    document.getElementById('lhim-restart-btn').addEventListener('click', restartSession);
    document.getElementById('lhim-transfer-btn').addEventListener('click', transferToHuman);
    document.getElementById('lhim-contact-tab').addEventListener('click', function () {
      openStoreLink(CONTACT_URLS);
    });
    document.getElementById('lhim-restart-tab').addEventListener('click', restartSession);
    bindMoreMenuHover();
    document.getElementById('lhim-more-faq').addEventListener('click', function () {
      openStoreLink(FAQ_URLS);
    });
    document.getElementById('lhim-more-human').addEventListener('click', transferToHuman);
    document.getElementById('lhim-attachment').addEventListener('click', openAttachmentPicker);
    document.getElementById('lhim-attachment-input').addEventListener('change', handleAttachmentChange);
    document.getElementById('lhim-cancel-order').addEventListener('click', cancelOrderFlow);
    document.getElementById('lhim-send').addEventListener('click', sendMessage);
    document.getElementById('lhim-chat-start').addEventListener('click', handleChatStart);
    document.getElementById('lhim-guest-start').addEventListener('click', handleGuestStart);
    document.getElementById('lhim-guest-name').addEventListener('input', updateGuestStartState);
    document.getElementById('lhim-guest-email').addEventListener('input', updateGuestStartState);
    document.getElementById('lhim-guest-consent').addEventListener('change', updateGuestStartState);
    document.getElementById('lhim-msgs').addEventListener('scroll', handleMessagesScroll);

    // Enter 发送（Shift+Enter 换行）
    document.getElementById('lhim-input').addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        sendMessage();
      }
    });
  }

  // ─── 浮窗开关 ────────────────────────────────────────────────────────────────
  function toggleWindow() {
    isOpen ? closeWindow() : openWindow();
  }

  function openWindow() {
    isOpen = true;
    document.getElementById('lhim-window').classList.add('lhim-open');
    hideBadge();

    if (!currentRoomId) {
      // 判断是否已登录
      if (isLoggedIn) {
        // 已登录用户直接进入聊天页面
        showChatView();
        initSession();
      } else {
        // 游客：检查是否之前已经输入过信息（localStorage 缓存）
        var cachedName = localStorage.getItem('lhim_guest_name');
        var cachedEmail = localStorage.getItem('lhim_guest_email');
        if (cachedName && cachedEmail) {
          guestName = cachedName;
          guestEmail = cachedEmail;
          showChatView();
          initSession();
        } else {
          // 显示游客表单
          showGuestForm();
        }
      }
    }
  }

  function closeWindow() {
    isOpen = false;
    document.getElementById('lhim-window').classList.remove('lhim-open');
  }

  function bindMoreMenuHover() {
    var wrap = document.querySelector('.lhim-more-wrap');
    if (!wrap) return;

    wrap.addEventListener('mouseenter', function () {
      if (moreCloseTimer) {
        clearTimeout(moreCloseTimer);
        moreCloseTimer = null;
      }
      wrap.classList.add('lhim-more-open');
    });

    wrap.addEventListener('mouseleave', function () {
      if (moreCloseTimer) clearTimeout(moreCloseTimer);
      moreCloseTimer = setTimeout(function () {
        wrap.classList.remove('lhim-more-open');
        moreCloseTimer = null;
      }, 200);
    });
  }

  // ─── 视图切换 ────────────────────────────────────────────────────────────────
  function showGuestForm() {
    document.getElementById('lhim-window').classList.remove('lhim-chat-mode');
    document.getElementById('lhim-guest-form').style.display = 'flex';
    document.getElementById('lhim-tips').style.display = 'none';
    document.getElementById('lhim-msgs').style.display = 'none';
    document.getElementById('lhim-input-area').style.display = 'none';
    document.getElementById('lhim-restart-btn').style.display = 'none';
    document.getElementById('lhim-transfer-btn').style.display = 'none';
    updateGuestStartState();
  }

  function showChatView() {
    document.getElementById('lhim-window').classList.add('lhim-chat-mode');
    document.getElementById('lhim-guest-form').style.display = 'none';
    document.getElementById('lhim-msgs').style.display = 'block';
    document.getElementById('lhim-input-area').style.display = 'block';
    document.getElementById('lhim-restart-btn').style.display = '';
    document.getElementById('lhim-transfer-btn').style.display = '';
    updateSessionInputState();
  }

  function setRemoteStreamLoading(loading) {
    var msgs = document.getElementById('lhim-msgs');
    var inputArea = document.getElementById('lhim-input-area');
    if (msgs) {
      msgs.style.display = 'block';
      if (loading) {
        msgs.innerHTML = '<div class="lhim-loading-state"><span class="lhim-loading-spinner" aria-hidden="true"></span><span>' + escapeHtml(LOADING_CONVERSATION_LABEL) + '</span></div>';
      }
    }
    if (inputArea) inputArea.style.display = loading ? 'none' : 'block';
    if (loading) {
      showStatus(LOADING_CONVERSATION_LABEL, 'connecting');
    } else {
      showChatView();
      showStatus(STATUS_CONNECTED, 'connected');
    }
  }

  function setSessionEnded(ended) {
    sessionEnded = !!ended;
    updateSessionInputState();
  }

  function updateSessionInputState() {
    var inputArea = document.getElementById('lhim-input-area');
    var inputRow = document.getElementById('lhim-input-row');
    var input = document.getElementById('lhim-input');
    var attachmentBtn = document.getElementById('lhim-attachment');
    var chatStartBtn = document.getElementById('lhim-chat-start');
    if (!inputRow || !input || !attachmentBtn || !chatStartBtn) return;

    if (inputArea) inputArea.classList.toggle('lhim-session-ended', sessionEnded);
    inputRow.classList.toggle('lhim-session-ended', sessionEnded);
    input.disabled = sessionEnded;
    attachmentBtn.disabled = sessionEnded || conversationMode !== 'human';
    attachmentBtn.style.display = !sessionEnded && conversationMode === 'human' ? 'flex' : 'none';
    chatStartBtn.disabled = false;
    chatStartBtn.classList.remove('lhim-loading');

    if (sessionEnded) {
      var moreWrap = document.querySelector('.lhim-more-wrap');
      if (moreWrap) moreWrap.classList.remove('lhim-more-open');
    }
  }

  function handleChatStart() {
    if (!sessionEnded) return;

    var chatStartBtn = document.getElementById('lhim-chat-start');
    if (chatStartBtn) {
      chatStartBtn.disabled = true;
      chatStartBtn.classList.add('lhim-loading');
    }
    startNewAiSession();
  }

  function handleSessionEnded() {
    activeAiStream = null;
    streamingByMsgId = {};
    waitingRemoteStreamEnd = false;
    waitingRemoteStreamRoomId = '';
    disconnectWebSocket();
    setSessionEnded(true);
    showStatus(STATUS_CONVERSATION_ENDED, 'connecting');
  }

  // ─── 游客表单提交 ────────────────────────────────────────────────────────────
  function handleGuestStart() {
    var nameInput = document.getElementById('lhim-guest-name');
    var emailInput = document.getElementById('lhim-guest-email');
    var consentInput = document.getElementById('lhim-guest-consent');
    var startBtn = document.getElementById('lhim-guest-start');
    var errorEl = document.getElementById('lhim-form-error');

    var name = nameInput.value.trim();
    var email = emailInput.value.trim();
    var hasConsent = consentInput.checked;

    // 校验
    if (!email || !isValidEmail(email)) {
      errorEl.textContent = 'Please enter a valid email address.';
      errorEl.style.display = 'block';
      emailInput.focus();
      return;
    }
    if (!name) {
      errorEl.textContent = 'Please enter your name.';
      errorEl.style.display = 'block';
      nameInput.focus();
      return;
    }
    if (!hasConsent) {
      errorEl.textContent = 'Please agree to the Privacy Policy before starting.';
      errorEl.style.display = 'block';
      consentInput.focus();
      return;
    }

    errorEl.style.display = 'none';
    startBtn.classList.add('lhim-loading');
    startBtn.disabled = true;
    guestName = name;
    guestEmail = email;

    // 缓存到 localStorage
    localStorage.setItem('lhim_guest_name', name);
    localStorage.setItem('lhim_guest_email', email);

    // 切换到聊天视图并初始化会话
    showChatView();
    initSession();
  }

  function updateGuestStartState() {
    var nameInput = document.getElementById('lhim-guest-name');
    var emailInput = document.getElementById('lhim-guest-email');
    var consentInput = document.getElementById('lhim-guest-consent');
    var startBtn = document.getElementById('lhim-guest-start');
    var errorEl = document.getElementById('lhim-form-error');
    if (!nameInput || !emailInput || !consentInput || !startBtn) return;

    var canStart = !!nameInput.value.trim() && isValidEmail(emailInput.value.trim()) && consentInput.checked;
    startBtn.disabled = !canStart;
    startBtn.classList.remove('lhim-loading');
    if (errorEl) {
      errorEl.textContent = '';
      errorEl.style.display = 'none';
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // ─── 状态栏 ──────────────────────────────────────────────────────────────────
  function showStatus(text, type) {
    var el = document.getElementById('lhim-status');
    el.textContent = text;
    el.className = 'lhim-' + type;
    el.style.display = 'block';
    if (type === 'connected') {
      setTimeout(function () { el.style.display = 'none'; }, 3000);
    }
  }

  // ─── 未读角标 ────────────────────────────────────────────────────────────────
  var unreadCount = 0;

  function showBadge() {
    unreadCount++;
    var badge = document.getElementById('lhim-badge');
    badge.textContent = unreadCount > 9 ? '9+' : unreadCount;
    badge.style.display = 'flex';
  }

  function hideBadge() {
    unreadCount = 0;
    var badge = document.getElementById('lhim-badge');
    badge.style.display = 'none';
  }

  // ─── HTTP 请求（通过 Shopify App Proxy） ─────────────────────────────────────
  /**
   * 所有 API 请求通过 Shopify App Proxy 转发，Shopify 会自动附加鉴权参数
   * 前端额外附加 fp (fingerprint) 参数用于游客身份识别
   */
  function apiRequest(path, method, body) {
    var fp = getFingerprint();
    var separator = path.indexOf('?') >= 0 ? '&' : '?';
    var url = APP_PROXY_PATH + path + separator + 'source=dtc&fp=' + encodeURIComponent(fp);

    var headers = { 'Content-Type': 'application/json' };
    var opts = { method: method || 'GET', headers: headers };
    if (body && method !== 'GET') {
      opts.body = JSON.stringify(body);
    }
    return fetch(url, opts)
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .catch(function (e) { return { ok: false, error: e.message }; });
  }

  function apiFormRequest(path, formData) {
    var fp = getFingerprint();
    var separator = path.indexOf('?') >= 0 ? '&' : '?';
    var url = APP_PROXY_PATH + path + separator + 'source=dtc&fp=' + encodeURIComponent(fp);

    return fetch(url, { method: 'POST', body: formData })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .catch(function (e) { return { ok: false, error: e.message }; });
  }

  // ─── 会话初始化 ──────────────────────────────────────────────────────────────
  function initSession() {
    showStatus(STATUS_INITIALIZING, 'connecting');

    // 调用 DTC 会话列表接口
    apiRequest('/sigen-im/chat/cs/sessions/dtc', 'GET').then(function (res) {
      if (res.ok && res.data && res.data.code === 0 && res.data.data && res.data.data.length > 0) {
        var sessions = res.data.data;
        // 查找是否有非结束态(status !== 3)的会话
        var activeSession = null;
        for (var i = 0; i < sessions.length; i++) {
          if (sessions[i].status !== 3) {
            activeSession = sessions[i];
            break;
          }
        }

        if (activeSession) {
          // 有活跃会话，直接使用
          currentRoomId = activeSession.roomId;
          resetHumanTransferUnlockState();
          applyStoredConversationMode();
          currentUid = resolveUid(activeSession);
          if (currentUid) localStorage.setItem('lhim_uid', currentUid);
          showStatus(STATUS_CONNECTED, 'connected');
          connectWebSocket();
          loadMessages();
          //loadTips();
        } else {
          // 所有会话都是结束态，创建新会话
          createSession({ loadMessagesOnSuccess: true });
        }
      } else if (res.ok && res.data && res.data.code === 0) {
        // 没有会话列表，创建新会话
        createSession({ loadMessagesOnSuccess: true });
      } else {
        showStatus(STATUS_FAILED_TO_LOAD_SESSIONS, 'error');
        console.error('[IM] 获取会话列表失败', res);
      }
    });
  }

  function createSession(options) {
    options = options || {};
    var userName = isLoggedIn ? SHOPIFY_CUSTOMER_NAME : guestName;
    var userEmail = isLoggedIn ? SHOPIFY_CUSTOMER_EMAIL : guestEmail;

    var body = {
      userName: userName || 'Guest',
      userEmail: userEmail || ''
    };

    showStatus(STATUS_CREATING_CONVERSATION, 'connecting');

    apiRequest('/sigen-im/chat/cs/session/dtc', 'POST', body).then(function (res) {
      if (res.ok && res.data && res.data.code === 0 && res.data.data) {
        var data = res.data.data;
        currentRoomId = data.roomId;
        resetHumanTransferUnlockState();
        setSessionEnded(false);
        switchToAiMode();
        if (data.uid) {
          currentUid = String(data.uid);
        }
        showStatus(STATUS_CONNECTED, 'connected');

        connectWebSocket();
        if (options.loadMessagesOnSuccess) {
          loadMessages().then(function () {
            appendWelcomeMessage();
          });
        } else {
          // 前端生成欢迎语
          appendWelcomeMessage();
        }
        //loadTips();
      } else {
        updateSessionInputState();
        showStatus(STATUS_FAILED_TO_CREATE_CONVERSATION, 'error');
        console.error('[LuohuoIM] 创建会话失败', res);
      }
    }).catch(function (error) {
      updateSessionInputState();
      showStatus(STATUS_FAILED_TO_CREATE_CONVERSATION, 'error');
      console.error('[LuohuoIM] 创建会话异常', error);
    });
  }

  /** 从会话对象 / localStorage 解析 uid，供 WebSocket 连接使用 */
  function resolveUid(session) {
    if (session && session.userUid != null && session.userUid !== '') {
      return String(session.userUid);
    }
    var cached = localStorage.getItem('lhim_uid');
    if (cached) return cached;
    return currentUid;
  }

  // ─── 欢迎语 ──────────────────────────────────────────────────────────────────
  function appendWelcomeMessage(options) {
    options = options || {};
    if (options.force) {
      if (hasRecentWelcomeMessage(currentRoomId, 1500)) {
        renderMessages({ scrollToBottom: true });
        return;
      }
    } else if (hasLatestWelcomeMessage(currentRoomId)) {
      renderMessages({ scrollToBottom: true });
      return;
    }

    var welcomeItem = {
      fromUser: { uid: 'support_bot', name: 'Intelligent Customer Service' },
      message: {
        id: 'welcome_' + Date.now(),
        roomId: currentRoomId,
        type: 1,
        body: { content: WELCOME_PROMPT },
        sendTime: Date.now()
      }
    };
    messages.push(welcomeItem);
    renderMessages();
  }

  function hasRecentWelcomeMessage(roomId, windowMs) {
    var now = Date.now();
    return messages.some(function (item) {
      if (!isWelcomeMessageItem(item)) return false;
      if (roomId && String(item.message.roomId) !== String(roomId)) return false;
      var ms = parseMessageSendTime(item.message.sendTimeStamp != null ? item.message.sendTimeStamp : item.message.sendTime);
      return ms && now - ms <= windowMs;
    });
  }

  function hasLatestWelcomeMessage(roomId) {
    for (var i = messages.length - 1; i >= 0; i--) {
      var item = messages[i];
      if (!item || !item.message) continue;
      if (roomId && String(item.message.roomId) !== String(roomId)) continue;
      return isWelcomeMessageItem(item);
    }
    return false;
  }

  function hasWelcomeMessage(roomId) {
    return messages.some(function (item) {
      if (!isWelcomeMessageItem(item)) return false;
      return !roomId || String(item.message.roomId) === String(roomId);
    });
  }

  function isWelcomeMessageItem(item) {
    if (!item || !item.message || !item.message.body) return false;
    var content = String(item.message.body.content || '').trim();
    return content === WELCOME_PROMPT || String(item.message.id || '').indexOf('welcome_') === 0;
  }

  function appendSupportHoursMessage() {
    messages.push({
      fromUser: { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT' },
      message: {
        id: 'support_hours_' + currentRoomId + '_' + Date.now(),
        roomId: currentRoomId,
        type: 1,
        body: { content: SUPPORT_HOURS_PROMPT },
        sendTime: Date.now()
      }
    });
    renderMessages();
  }

  function isHumanAgentGreetingItem(item, roomId) {
    if (!item || !item.message) return false;
    if (roomId && item.message.roomId != null && item.message.roomId !== '' &&
      String(item.message.roomId) !== String(roomId)) return false;
    var msgId = String(item.message.id || '');
    var content = String(item.message.body && item.message.body.content || '').trim();
    return msgId.indexOf('human_greeting_' + roomId) === 0 || isHumanAgentGreetingContent(content);
  }

  function normalizePromptText(text) {
    return String(text || '')
      .replace(/[\u2010-\u2015]/g, '-')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function isHumanAgentGreetingContent(content) {
    var normalized = normalizePromptText(content);
    if (!normalized) return false;
    if (normalized === normalizePromptText(HUMAN_AGENT_GREETING_PROMPT)) return true;
    return normalized.indexOf("You've been connected to a live agent.") === 0 &&
      normalized.indexOf("We'll be with you shortly") >= 0 &&
      normalized.indexOf("feel free to add any extra details") >= 0;
  }

  function removeHumanAgentGreetingsInRoom(roomId) {
    for (var i = messages.length - 1; i >= 0; i--) {
      if (isHumanAgentGreetingItem(messages[i], roomId)) {
        messages.splice(i, 1);
      }
    }
  }

  function isCancelOrderMessageItem(item) {
    if (!item || !item.message) return false;
    if (String(item.message.type) === '24') return true;
    var content = String(item.message.body && item.message.body.content || '');
    return content.indexOf(CANCEL_ORDER_PROMPT) >= 0;
  }

  function ensureHumanGreetingBeforeMessage(item) {
    if (!item || !item.message || !isCancelOrderMessageItem(item)) return;
    var roomId = item.message.roomId || currentRoomId;
    if (!roomId) return;
    activateRoomFromWsEvent(String(roomId), 'human');
    appendHumanAgentGreeting();
  }

  function appendHumanAgentGreeting() {
    if (!currentRoomId) return;

    removeHumanAgentGreetingsInRoom(currentRoomId);

    messages.push({
      fromUser: { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT'  },
      message: {
        id: 'human_greeting_' + currentRoomId + '_' + Date.now(),
        roomId: currentRoomId,
        type: 1,
        body: { content: HUMAN_AGENT_GREETING_PROMPT },
        sendTime: Date.now(),
        _humanAgent: true
      }
    });
    renderMessages({ scrollToBottom: true });
  }

  function appendCancelOrderAgentMessage() {
    var tempId = 'cancel_order_' + currentRoomId + '_' + Date.now();
    messages.push({
      fromUser: { uid: 'human_agent', name: 'Human Agent' },
      message: {
        id: tempId,
        roomId: currentRoomId,
        type: 1,
        body: { content: CANCEL_ORDER_PROMPT },
        sendTime: Date.now(),
        _humanAgent: true
      }
    });
    renderMessages({ scrollToBottom: true });
  }

  function getCurrentStoreKey() {
    var host = window.location.hostname || '';
    if (host.indexOf('de-store.sigenergy.com') >= 0) return 'de';
    return 'eu';
  }

  function openStoreLink(urls) {
    var target = getStoreUrl(urls);
    window.open(target, '_blank', 'noopener');
  }

  function getStoreUrl(urls) {
    return urls[getCurrentStoreKey()] || urls.eu;
  }

  function getConversationModeKey(roomId) {
    return 'lhim_conversation_mode_' + (roomId || 'global');
  }

  function getStoredConversationMode(roomId) {
    if (!roomId) return 'ai';
    var mode = localStorage.getItem(getConversationModeKey(roomId));
    return mode === 'human' ? 'human' : 'ai';
  }

  function storeConversationMode(mode) {
    conversationMode = mode === 'human' ? 'human' : 'ai';
    if (currentRoomId) {
      localStorage.setItem(getConversationModeKey(currentRoomId), conversationMode);
    }
  }

  function resetHumanTransferUnlockState() {
    localAiReplyCount = 0;
    pendingLocalAiReplyCount = 0;
    countedLocalAiReplyIds = {};
  }

  function applyStoredConversationMode() {
    conversationMode = getStoredConversationMode(currentRoomId);
    var subtitle = document.getElementById('lhim-subtitle');
    if (subtitle) subtitle.textContent = conversationMode === 'human' ? 'Live Agent Support' : 'How can we help you?';
    updateHumanTransferVisibility();
    updateSessionInputState();
  }

  function switchToAiMode() {
    interruptedAiRoomId = null;
    ignoredInterruptedMsgIds = {};
    interruptedAiUntil = 0;
    storeConversationMode('ai');
    var subtitle = document.getElementById('lhim-subtitle');
    if (subtitle) subtitle.textContent = 'How can we help you?';
    updateHumanTransferVisibility();
    updateSessionInputState();
  }

  function switchToHumanMode() {
    storeConversationMode('human');
    var subtitle = document.getElementById('lhim-subtitle');
    if (subtitle) subtitle.textContent = 'Live Agent Support';
    updateHumanTransferVisibility();
    updateSessionInputState();
  }

  // ─── Restart 会话 ────────────────────────────────────────────────────────────
  function restartSession() {
    var wasHumanMode = conversationMode === 'human';
    switchToAiMode();
    if (wasHumanMode) {
      showStatus(STATUS_BACK_TO_AI_SUPPORT, 'connected');
    }
    startNewAiSession();
  }

  function startNewAiSession() {
    // 断开当前 WS
    disconnectWebSocket();

    appendNewMessageDivider();

    // 重置状态
    currentRoomId = null;
    historyCursor = null;
    hasMoreHistory = false;
    loadingMoreHistory = false;
    streamingByMsgId = {};
    activeAiStream = null;
    waitingRemoteStreamEnd = false;
    waitingRemoteStreamRoomId = '';
    interruptedAiRoomId = null;
    ignoredInterruptedMsgIds = {};
    interruptedAiUntil = 0;
    pendingHumanTransfer = false;
    transferringToHuman = false;
    renderMessages();
    updateHumanTransferVisibility();

    // 创建新会话
    createSession({ loadMessagesOnSuccess: true });
  }

  function appendNewMessageDivider() {
    messages.push({
      fromUser: { uid: 'system', name: 'System' },
      message: {
        id: 'new_message_' + Date.now(),
        roomId: currentRoomId || 'local',
        type: 'new_message_divider',
        body: { content: NEW_MESSAGE_LABEL },
        sendTime: Date.now()
      }
    });
  }

  // ─── 加载历史消息 ────────────────────────────────────────────────────────────
  function loadMessages(cursor) {
    if (!currentRoomId) return Promise.resolve();
    if (cursor && loadingMoreHistory) return Promise.resolve();

    var isLoadingOlder = !!cursor;
    if (isLoadingOlder) loadingMoreHistory = true;

    var path = '/sigen-im/chat/cs/user/msgs/dtc?roomId=' + encodeURIComponent(currentRoomId) +
      '&pageSize=' + encodeURIComponent(CHAT_PAGE_SIZE);
    if (cursor) {
      path += '&cursor=' + encodeURIComponent(cursor);
    }
    var container = document.getElementById('lhim-msgs');
    var previousScrollHeight = container ? container.scrollHeight : 0;
    var previousScrollTop = container ? container.scrollTop : 0;

    return apiRequest(path, 'GET').then(function (res) {
      if (res.ok && res.data && res.data.code === 0 && res.data.data) {
        var data = res.data.data;
        var historyMessages = normalizeHistoryMessages(data.list || []);
        historyCursor = data.cursor || null;
        hasMoreHistory = !data.isLast;

        if (isLoadingOlder) {
          messages = mergeMessages(historyMessages, messages);
          renderMessages({
            preserveScroll: true,
            previousScrollHeight: previousScrollHeight,
            previousScrollTop: previousScrollTop
          });
        } else {
          messages = historyMessages;
          renderMessages({ scrollToBottom: true });
        }
      }
    }).catch(function () {
      // 加载更多失败，静默处理
    }).then(function () {
      if (isLoadingOlder) loadingMoreHistory = false;
    });
  }

  function loadOlderMessages() {
    if (!currentRoomId || !historyCursor || !hasMoreHistory || loadingMoreHistory) return;
    loadMessages(historyCursor);
  }

  function handleMessagesScroll(e) {
    var container = e.currentTarget;
    if (!container || container.scrollTop > 48) return;
    loadOlderMessages();
  }

  function normalizeHistoryMessages(list) {
    return list.map(function (item) {
      item = normalizeSpecialMessage(item);
      return markHumanAgentMessage(item);
    }).filter(function (item) {
      return item && item.message;
    });
  }

  function normalizeSpecialMessage(item) {
    normalizeMessageRoomId(item);
    normalizeMessageSendTime(item && item.message);
    item = normalizeWelcomeMessage(item);
    item = normalizeSupportHoursMessage(item);
    item = normalizeCancelOrderHistoryMessage(item);
    return item;
  }

  function normalizeMessageRoomId(item) {
    if (!item || !item.message) return;
    if ((item.message.roomId == null || item.message.roomId === '') && item.roomId != null && item.roomId !== '') {
      item.message.roomId = item.roomId;
    }
  }

  function normalizeMessageSendTime(msg) {
    if (!msg) return;
    var ts = msg.sendTimeStamp != null && msg.sendTimeStamp !== '' ? msg.sendTimeStamp : msg.sendTime;
    var ms = parseMessageSendTime(ts);
    if (ms) msg.sendTime = ms;
  }

  function parseMessageSendTime(ts) {
    if (ts == null || ts === '') return 0;

    if (typeof ts === 'number' && !isNaN(ts)) return ts;

    if (typeof ts === 'string') {
      var numeric = Number(ts);
      if (!isNaN(numeric) && numeric > 0) return numeric;
      var parsed = new Date(ts).getTime();
      return isNaN(parsed) ? 0 : parsed;
    }

    if (Array.isArray(ts) && ts.length >= 3) {
      var year = Number(ts[0]);
      var month = Number(ts[1]);
      var day = Number(ts[2]);
      var hour = ts.length > 3 ? Number(ts[3]) : 0;
      var minute = ts.length > 4 ? Number(ts[4]) : 0;
      var second = ts.length > 5 ? Number(ts[5]) : 0;
      var nano = ts.length > 6 ? Number(ts[6]) : 0;
      var millis = nano ? Math.floor(nano / 1000000) : 0;
      var date = new Date(year, month - 1, day, hour, minute, second, millis);
      return isNaN(date.getTime()) ? 0 : date.getTime();
    }

    return 0;
  }

  function normalizeWelcomeMessage(item) {
    if (!item || !item.message || String(item.message.type) !== '22') return item;

    var msg = item.message;
    msg.body = msg.body || {};
    var content = String(msg.body.content || '').trim();
    msg.body.content = content && content.indexOf(WELCOME_PROMPT) < 0
      ? content + '\n\n' + WELCOME_PROMPT
      : (content || WELCOME_PROMPT);
    msg._originalType = msg.type;
    msg.type = 1;

    if (!item.fromUser || !isBotSender(item.fromUser)) {
      item.fromUser = { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT' };
    }

    return item;
  }

  function normalizeSupportHoursMessage(item) {
    if (!item || !item.message || String(item.message.type) !== '26') return item;

    var msg = item.message;
    msg.body = msg.body || {};
    msg.body.content = SUPPORT_HOURS_PROMPT;
    msg._originalType = msg.type;
    msg.type = 1;

    if (!item.fromUser || !isBotSender(item.fromUser) || String(item.fromUser.uid) === String(currentUid)) {
      item.fromUser = { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT' };
    }

    return item;
  }

  function normalizeCancelOrderHistoryMessage(item) {
    if (!item || !item.message || String(item.message.type) !== '24') return item;

    var msg = item.message;
    msg.body = msg.body || {};
    var content = String(msg.body.content || '').trim();
    msg.body.content = content && content.indexOf(CANCEL_ORDER_PROMPT) < 0
      ? content + '\n\n' + CANCEL_ORDER_PROMPT
      : (content || CANCEL_ORDER_PROMPT);
    msg._originalType = msg.type;
    msg.type = 1;
    msg._humanAgent = true;

    if (!item.fromUser || isBotSender(item.fromUser) || String(item.fromUser.uid) === String(currentUid)) {
      item.fromUser = { uid: 'human_agent', name: 'Human Agent' };
    }

    return item;
  }

  function isRestartWelcomeMessageItem(item) {
    if (!item || !item.message) return false;
    return String(item.message.type) === '22' || String(item.message._originalType || '') === '22';
  }

  function handleRestartWelcomeMessage(roomId) {
    if (roomId) {
      activateRoomFromWsEvent(String(roomId), 'ai');
    }
    resetHumanTransferUnlockState();
    pendingHumanTransfer = false;
    transferringToHuman = false;
    switchToAiMode();
    updateActionTabsVisibility();
    return true;
  }

  function mergeMessages(olderMessages, currentMessages) {
    var seen = {};
    var merged = [];

    currentMessages.forEach(function (item) {
      var id = getMessageIdentity(item);
      if (id) seen[id] = true;
    });

    olderMessages.forEach(function (item) {
      var id = getMessageIdentity(item);
      if (!id || !seen[id]) {
        merged.push(item);
        if (id) seen[id] = true;
      }
    });

    return merged.concat(currentMessages);
  }

  function getMessageIdentity(item) {
    if (!item || !item.message) return '';
    var msg = item.message;
    return String(msg.id || msg.tempId || '');
  }

  // ─── 渲染消息 ────────────────────────────────────────────────────────────────
  function renderMessages(options) {
    options = options || {};
    var container = document.getElementById('lhim-msgs');
    if (!container) return;
    updateActionTabsVisibility();

    if (messages.length === 0) {
      container.innerHTML = '<div class="lhim-empty"><div class="lhim-empty-icon">&#x2709;&#xFE0F;</div><div>No messages yet. Start a conversation!</div></div>';
      return;
    }

    var firstMessage = messages.length === 1;
    // 按消息 ID / sendTime 升序排列
    var sorted = messages.map(function (item, index) {
      return { item: item, index: index };
    }).sort(function (a, b) {
      var aMsg = a.item.message || {};
      var bMsg = b.item.message || {};
      var aTime = getMessageSortTime(aMsg);
      var bTime = getMessageSortTime(bMsg);
      return aTime === bTime ? a.index - b.index : aTime - bTime;
    }).map(function (entry) {
      return entry.item;
    });

    container.innerHTML = sorted.map(function (item) {
      return buildMessageHTML(item);
    }).join('');
    updateActionTabsVisibility();

    if (!firstMessage) {
      container.style.paddingTop = '20px';
    } else {
      container.style.paddingTop = '72px';
    }

    if (options.preserveScroll) {
      container.scrollTop = container.scrollHeight - options.previousScrollHeight + options.previousScrollTop;
    } else if (options.scrollToBottom !== false) {
      container.scrollTop = container.scrollHeight;
    }
  }

  function buildMessageHTML(item) {
    var msg = item.message;
    var fromUser = item.fromUser || {};
    var isSelf = isSelfMessageItem(item);
    var isSystem = String(fromUser.uid) === 'system';
    var msgType = msg.type;
    var body = msg.body || {};
    var msgId = msg.id != null ? String(msg.id) : '';
    var isStreaming = !!(msg._streaming || (msgId && streamingByMsgId[msgId]));

    if (msgType === 'new_message_divider') {
      return buildNewMessageDividerHTML(body.content || NEW_MESSAGE_LABEL, msgId);
    }

    // 系统消息
    if (isSystem) {
      return buildSystemMsgHTML(body.content || 'System message', msgId);
    }

    // 内容渲染
    var content = '';
    if (msgType === 1) {
      content = isSelf ? escapeHtml(body.content || '') : renderMarkdown(body.content || '');
    } else if (msgType === 3 || msgType === 'image') {
      content = renderAttachmentHTML(body, 'image');
    } else if (msgType === 6 || msgType === 'video') {
      content = renderAttachmentHTML(body, 'video');
    } else if (msgType === 4 || msgType === 'file') {
      content = renderAttachmentHTML(body, 'file');
    } else if (msgType === 20) {
      content = '&#x2753; ' + escapeHtml(body.content || '');
    } else if (msgType === 100 || msgType === 101 || msgType === 102) {
      return buildSystemMsgHTML(body.content || 'System message', msgId);
    } else {
      content = escapeHtml(body.content || JSON.stringify(body));
    }
    var isTypingPlaceholder = !isSelf && isStreaming && !String(body.content || '').trim();
    if (isTypingPlaceholder) {
      content = buildTypingDotsHTML();
    }

    var avatarText = isSelf ? 'Me' : 'AI';
    var senderName = isSelf ? 'Me' : (fromUser.name || 'Support');
    var timeStr = formatTime(msg.sendTimeStamp != null && msg.sendTimeStamp !== '' ? msg.sendTimeStamp : msg.sendTime);
    var bubbleClass = 'lhim-bubble' + (isStreaming ? ' lhim-streaming' : '') + (isTypingPlaceholder ? ' lhim-typing-bubble' : '');
    var stateText = msg._failed ? 'Failed to send' : (msg._pending ? '...' : '');
    var timeHtml = isSelf ? '<div class="lhim-time">' + timeStr + '</div>' : '';
    var stateHtml = stateText ? '<div class="lhim-send-state">' + stateText + '</div>' : '';
    var isHumanAgent = !isSelf && !isBotSender(fromUser) && (msg._humanAgent || isHumanAgentSender(fromUser));
    var avatarClass = 'lhim-avatar' + (isHumanAgent ? ' lhim-human-avatar' : '');
    var avatarHtml = isSelf ? '' : '  <div class="' + avatarClass + '">' + avatarText + '</div>';
    var msgClass = 'lhim-msg ' + (isSelf ? 'lhim-self ' : '') + (msg._pending ? 'lhim-pending ' : '') + (msg._failed ? 'lhim-failed ' : '');

    return [
      '<div class="' + msgClass.trim() + '" data-msg-id="' + escapeAttr(msgId) + '">',
      avatarHtml,
      '  <div class="lhim-bubble-wrap">',
      '    <div class="' + bubbleClass + '">' + content + '</div>',
      timeHtml,
      stateHtml,
      '  </div>',
      '</div>'
    ].join('');
  }

  function buildNewMessageDividerHTML(text, msgId) {
    var idAttr = msgId ? ' data-msg-id="' + escapeAttr(msgId) + '"' : '';
    return '<div class="lhim-new-divider"' + idAttr + '><span>' + escapeHtml(text) + '</span></div>';
  }

  function getMessageSortTime(msg) {
    if (!msg) return 0;
    if (msg._sortTime != null && msg._sortTime !== '') return parseMessageSendTime(msg._sortTime);
    return parseMessageSendTime(msg.sendTimeStamp != null ? msg.sendTimeStamp : msg.sendTime);
  }

  function markRealtimeMessageOrder(item) {
    if (!item || !item.message || item.message._sortTime != null) return;
    realtimeMessageOrder++;
    item.message._sortTime = Date.now() + realtimeMessageOrder / 1000;
  }

  function buildTypingDotsHTML() {
    return '<span class="lhim-typing-dots" aria-label="AI is typing"><span></span><span></span><span></span></span>';
  }

  function renderAttachmentHTML(body, kind) {
    var url = getAttachmentUrl(body);
    var name = body.fileName || body.filename || body.name || body.content || 'Attachment';
    var safeName = escapeHtml(name);
    if (!url) return safeName;

    var safeUrl = escapeAttr(url);
    if (kind === 'image') {
      return '<a href="' + safeUrl + '" target="_blank" rel="noopener"><img class="lhim-attachment-media" src="' + safeUrl + '" alt="' + escapeAttr(name) + '" /></a>';
    }
    if (kind === 'video') {
      return '<video class="lhim-attachment-video" src="' + safeUrl + '" controls preload="metadata"></video>';
    }
    return '<a class="lhim-attachment-file" href="' + safeUrl + '" target="_blank" rel="noopener"><span>' + safeName + '</span></a>';
  }

  function getAttachmentUrl(body) {
    var url = body.url || body.fileUrl || body.file_url || body.attachmentUrl || body.attachment_url || body.path || '';
    if (!url && body.content && /^https?:\/\//.test(body.content)) return body.content;
    return url;
  }

  function buildSystemMsgHTML(text, msgId) {
    var idAttr = msgId ? ' data-msg-id="' + escapeAttr(msgId) + '"' : '';
    return [
      '<div class="lhim-msg lhim-system"' + idAttr + '>',
      '  <div class="lhim-bubble-wrap" style="width:100%">',
      '    <div class="lhim-bubble">' + escapeHtml(text) + '</div>',
      '  </div>',
      '</div>'
    ].join('');
  }

  function scrollMessagesToBottom() {
    var container = document.getElementById('lhim-msgs');
    if (container) container.scrollTop = container.scrollHeight;
  }

  function getStreamMsgId(data) {
    if (!data || !data.message) return '';
    var m = data.message;
    return String(m.id || m.tempId || m.streamId || '');
  }

  function isBackendStreamMessageId(msgId) {
    var id = String(msgId || '');
    return id.indexOf('stream_') >= 0 && id.indexOf('ai_stream_') !== 0;
  }

  function isStreamEnvelope(envelope) {
    if (!envelope) return false;
    var type = envelope.type;
    if (type === 'receiveStreamMessage' || type === 'streamMessage' || type === 'messageStream' || type === 'streamChunk') {
      return true;
    }
    if (type !== 'receiveMessage' || !envelope.data) return false;

    var d = envelope.data;
    var m = d.message || {};

    if (envelope.stream === true || d.stream === true || m.stream === true || m.streaming === true) return true;

    var status = envelope.streamStatus || d.streamStatus || m.streamStatus;
    if (status === 'start' || status === 'chunk' || status === 'delta') return true;

    if (d.finished === false || m.finished === false || d.streamEnd === false || m.streamEnd === false) return true;
    if (d.chunk != null && d.chunk !== '' || m.chunk != null && m.chunk !== '') return true;
    if (m.body && m.body.delta != null && m.body.delta !== '') return true;

    var id = getStreamMsgId(d);
    if (id && streamingByMsgId[id]) return true;

    return false;
  }

  function isStreamFinished(envelope, data) {
    if (!envelope && !data) return false;
    var d = data || (envelope && envelope.data);
    var m = d && d.message || {};

    if (envelope && (envelope.finished === true || envelope.streamEnd === true)) return true;
    if (d && (d.finished === true || d.streamEnd === true)) return true;
    if (m.finished === true || m.streamEnd === true) return true;

    var status = (envelope && envelope.streamStatus) || (d && d.streamStatus) || m.streamStatus;
    return status === 'end' || status === 'done';
  }

  function startStreamingMessage(data, msgId) {
    if (!msgId) msgId = 'stream_' + Date.now();

    var item = JSON.parse(JSON.stringify(data));
    item.message.id = msgId;
    item.message.body = item.message.body || {};
    if (!item.message.body.content) item.message.body.content = '';
    item.message._streaming = true;

    var idx = messages.findIndex(function (m) { return m.message && String(m.message.id) === String(msgId); });
    if (idx < 0) messages.push(item);
    else messages[idx] = item;

    streamingByMsgId[msgId] = { content: item.message.body.content || '' };
    renderMessages();
  }

  function applyStreamDelta(msgId, data) {
    var stream = streamingByMsgId[msgId];
    if (!stream) return;

    var m = data.message || {};
    var body = m.body || {};
    var envelopeChunk = data.chunk != null ? data.chunk : null;
    var msgChunk = m.chunk != null ? m.chunk : null;

    if (body.delta != null && body.delta !== '') {
      stream.content += body.delta;
    } else if (envelopeChunk != null && envelopeChunk !== '') {
      stream.content += envelopeChunk;
    } else if (msgChunk != null && msgChunk !== '') {
      stream.content += msgChunk;
    } else if (body.content != null) {
      stream.content = String(body.content);
    } else if (m.content != null) {
      stream.content = String(m.content);
    }

    var idx = messages.findIndex(function (item) { return item.message && String(item.message.id) === String(msgId); });
    if (idx >= 0) {
      messages[idx].message.body = messages[idx].message.body || {};
      messages[idx].message.body.content = stream.content;
      messages[idx].message._streaming = true;
    }
    if (activeAiStream && String(activeAiStream.msgId) === String(msgId)) {
      activeAiStream.content = stream.content;
    }
  }

  function updateStreamingBubble(msgId) {
    var container = document.getElementById('lhim-msgs');
    if (!container) return;

    var stream = streamingByMsgId[msgId];
    var row = container.querySelector('[data-msg-id="' + escapeAttr(msgId) + '"]');
    var bubble = row && row.querySelector('.lhim-bubble');

    if (bubble && stream) {
      bubble.innerHTML = renderMarkdown(stream.content);
      bubble.classList.add('lhim-streaming');
      scrollMessagesToBottom();
      return;
    }

    renderMessages();
  }

  function getFrameRoomId(frame, allowPrimitiveData) {
    if (!frame) return '';
    var data = frame.data;
    if (allowPrimitiveData && (typeof data === 'string' || typeof data === 'number')) return String(data);
    if (frame.roomId != null) return String(frame.roomId);
    if (data && data.roomId != null) return String(data.roomId);
    if (data && data.message && data.message.roomId != null) return String(data.message.roomId);
    return '';
  }

  function activateRoomFromWsEvent(roomId, mode) {
    if (!roomId) return true;
    if (currentRoomId && String(currentRoomId) === String(roomId)) {
      if (mode === 'human') switchToHumanMode();
      else if (mode === 'ai') switchToAiMode();
      return true;
    }

    currentRoomId = roomId;
    resetHumanTransferUnlockState();
    historyCursor = null;
    hasMoreHistory = false;
    loadingMoreHistory = false;
    streamingByMsgId = {};
    activeAiStream = null;
    interruptedAiRoomId = null;
    ignoredInterruptedMsgIds = {};
    interruptedAiUntil = 0;
    pendingHumanTransfer = false;
    transferringToHuman = false;
    setSessionEnded(false);

    if (mode === 'human') switchToHumanMode();
    else switchToAiMode();
    return true;
  }

  function isHumanTransferWsType(type) {
    var value = String(type || '').toLowerCase();
    return value === '23' ||
      value === 'humantransfer' ||
      value === 'human_transfer' ||
      value === 'transfertohuman' ||
      value === 'transfer_to_human' ||
      value === 'zendesktransfer' ||
      value === 'zendesk_transfer';
  }

  function isAiStreamEndWsType(type) {
    var value = String(type || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    return value === 'aistreamend' || value === 'streamend' || value === 'streamdone' || value === 'aistreamdone';
  }

  function getFrameStreamText(frame) {
    if (!frame) return null;

    var data = frame.data;
    if (typeof data === 'string') return data;
    if (!data) data = {};

    var msg = data.message || {};
    var body = msg.body || data.body || {};

    if (body.delta != null && body.delta !== '') return String(body.delta);
    if (data.delta != null && data.delta !== '') return String(data.delta);
    if (msg.delta != null && msg.delta !== '') return String(msg.delta);
    if (data.chunk != null && data.chunk !== '') return String(data.chunk);
    if (msg.chunk != null && msg.chunk !== '') return String(msg.chunk);
    if (body.content != null && body.content !== '') return String(body.content);
    if (data.content != null && data.content !== '') return String(data.content);
    if (msg.content != null && msg.content !== '') return String(msg.content);
    if (data.text != null && data.text !== '') return String(data.text);
    if (frame.content != null && frame.content !== '') return String(frame.content);
    if (frame.text != null && frame.text !== '') return String(frame.text);

    return null;
  }

  function startActiveAiStream(roomId, sortTime) {
    if (!roomId || String(roomId) !== String(currentRoomId)) return false;

    if (activeAiStream && String(activeAiStream.roomId) === String(roomId)) {
      return false;
    }

    if (!isOpen) showBadge();

    var createdAt = sortTime || Date.now();
    var msgId = 'ai_stream_' + createdAt;
    var item = {
      fromUser: { uid: 'ai', name: 'Support' },
      message: {
        id: msgId,
        roomId: roomId,
        type: 1,
        body: { content: '' },
        sendTime: createdAt,
        _sortTime: createdAt,
        _streaming: true
      }
    };

    activeAiStream = { roomId: roomId, msgId: msgId, content: '' };
    streamingByMsgId[msgId] = { content: '' };
    messages.push(item);
    renderMessages();
    return true;
  }

  function clearEmptyActiveAiStream(roomId) {
    if (!activeAiStream || String(activeAiStream.roomId) !== String(roomId) || activeAiStream.content) return;
    var msgId = activeAiStream.msgId;
    delete streamingByMsgId[msgId];
    messages = messages.filter(function (item) {
      return !(item.message && String(item.message.id) === String(msgId));
    });
    activeAiStream = null;
    renderMessages();
  }

  function adoptActiveAiStreamMsgId(msgId, roomId) {
    if (!msgId || !activeAiStream || String(activeAiStream.roomId) !== String(roomId)) return msgId;
    if (String(activeAiStream.msgId) === String(msgId)) return msgId;

    var oldMsgId = activeAiStream.msgId;
    var oldStream = streamingByMsgId[oldMsgId];
    if (!oldStream || activeAiStream.content) return msgId;

    var idx = messages.findIndex(function (item) {
      return item.message && String(item.message.id) === String(oldMsgId);
    });
    if (idx >= 0) messages[idx].message.id = msgId;

    delete streamingByMsgId[oldMsgId];
    streamingByMsgId[msgId] = { content: oldStream.content || '' };
    activeAiStream.msgId = msgId;
    return msgId;
  }

  function appendActiveAiStreamText(text) {
    if (!activeAiStream || text == null || text === '') return false;

    activeAiStream.content += String(text);
    streamingByMsgId[activeAiStream.msgId] = { content: activeAiStream.content };

    var idx = messages.findIndex(function (item) {
      return item.message && String(item.message.id) === String(activeAiStream.msgId);
    });
    if (idx >= 0) {
      messages[idx].message.body = messages[idx].message.body || {};
      messages[idx].message.body.content = activeAiStream.content;
      messages[idx].message._streaming = true;
    }

    updateStreamingBubble(activeAiStream.msgId);
    return true;
  }

  function handleActiveAiStreamFrame(frame) {
    if (!activeAiStream) return false;

    var roomId = getFrameRoomId(frame, false);
    if (roomId && String(roomId) !== String(activeAiStream.roomId)) return false;
    var data = frame && frame.data && typeof frame.data === 'object' ? frame.data : null;
    if (data && data.message && !isBackendStreamMessageId(getStreamMsgId(data) || data.message.id)) return false;

    var text = getFrameStreamText(frame);
    if (text == null || text === String(activeAiStream.roomId)) return false;

    return appendActiveAiStreamText(text);
  }

  function finishActiveAiStream(roomId) {
    if (!activeAiStream || String(roomId) !== String(activeAiStream.roomId)) return;

    var msgId = activeAiStream.msgId;
    var content = activeAiStream.content;
    delete streamingByMsgId[msgId];

    var idx = messages.findIndex(function (item) {
      return item.message && String(item.message.id) === String(msgId);
    });

    if (!content) {
      if (idx >= 0) messages.splice(idx, 1);
    } else if (idx >= 0) {
      messages[idx].message._streaming = false;
      messages[idx].message.body = messages[idx].message.body || {};
      messages[idx].message.body.content = content;
    }

    activeAiStream = null;
    renderMessages();
    if (idx >= 0) maybeUnlockHumanTransferAfterAiReply(messages[idx]);
    continuePendingHumanTransferIfReady();
  }

  function handleAiStreamTransfer(roomId) {
    roomId = roomId || currentRoomId;
    if (!roomId || String(roomId) !== String(currentRoomId)) return;

    var finishedWithContent = false;
    if (activeAiStream && String(activeAiStream.roomId) === String(roomId)) {
      if (activeAiStream.content) {
        finishedWithContent = true;
        finishActiveAiStream(roomId);
      } else {
        clearEmptyActiveAiStream(roomId);
      }
    }

    if (!finishedWithContent) {
      pendingLocalAiReplyCount = Math.max(0, pendingLocalAiReplyCount - 1);
    }
    updateActionTabsVisibility();
  }

  function markHumanAgentMessage(item) {
    if (!item || !item.message) return item;
    if (isBotSender(item.fromUser)) {
      delete item.message._humanAgent;
      return item;
    }
    if (isHumanAgentSender(item.fromUser)) {
      item.message._humanAgent = true;
    }
    return item;
  }

  function isSelfMessageItem(item) {
    return !!(item && item.fromUser && currentUid && String(item.fromUser.uid) === String(currentUid));
  }

  function isHumanAgentSender(fromUser) {
    if (isBotSender(fromUser)) return false;
    var uid = String(fromUser && fromUser.uid || '');
    var name = String(fromUser && fromUser.name || '').toLowerCase();
    if (!uid || uid === String(currentUid)) return false;
    uid = uid.toLowerCase();
    if (uid === 'ai' || uid === 'support_bot' || uid === 'system' || uid.indexOf('bot') >= 0 || uid.indexOf('ai') >= 0) return false;
    if (name.indexOf('intelligent customer service') >= 0 || name.indexOf('ai') >= 0 || name.indexOf('bot') >= 0) return false;
    return true;
  }

  function isBotSender(fromUser) {
    var type = String(fromUser && fromUser.type || '').toUpperCase();
    var uid = String(fromUser && fromUser.uid || '').toLowerCase();
    return type === 'BOT' || uid === 'ai' || uid === 'support_bot' || uid.indexOf('bot') >= 0 || uid.indexOf('ai') >= 0;
  }

  function getAiReplyCount() {
    if (!currentRoomId) return 0;
    return messages.reduce(function (count, item) {
      if (!item || !item.message || !isBotSender(item.fromUser)) return count;
      if (String(item.message.roomId) !== String(currentRoomId)) return count;
      if (String(item.message.id || '').indexOf('welcome_') === 0) return count;
      if (!item.message.body || !String(item.message.body.content || '').trim()) return count;
      return count + 1;
    }, 0);
  }

  function getHumanTransferUnlockedKey(roomId) {
    return 'lhim_human_transfer_unlocked_' + (roomId || currentRoomId || 'global');
  }

  function isHumanTransferUnlocked() {
    return localAiReplyCount >= HUMAN_TRANSFER_AI_REPLY_THRESHOLD;
  }

  function unlockHumanTransfer() {
    localAiReplyCount = Math.max(localAiReplyCount, HUMAN_TRANSFER_AI_REPLY_THRESHOLD);
  }

  function updateHumanTransferVisibility() {
    var btn = document.getElementById('lhim-more-human');
    if (!btn) return;
    var shouldShow = conversationMode === 'human' || isHumanTransferUnlocked();
    btn.style.display = shouldShow ? 'flex' : 'none';
    btn.disabled = pendingHumanTransfer || transferringToHuman;
  }

  function updateActionTabsVisibility() {
    updateHumanTransferVisibility();
    var tabs = document.getElementById('lhim-action-tabs');
    if (!tabs) return;

    var shouldHide = hasPendingAiReply();
    tabs.style.display = shouldHide ? 'none' : '';

    if (shouldHide) {
      var moreWrap = document.querySelector('.lhim-more-wrap');
      if (moreWrap) moreWrap.classList.remove('lhim-more-open');
    }
  }

  function markLocalAiReplyPending() {
    if (!currentRoomId || conversationMode === 'human') return false;
    pendingLocalAiReplyCount++;
    return true;
  }

  function rollbackLocalAiReplyPending(marked) {
    if (!marked) return;
    pendingLocalAiReplyCount = Math.max(0, pendingLocalAiReplyCount - 1);
  }

  function maybeUnlockHumanTransferAfterAiReply(item) {
    if (!item || !item.message || !isBotSender(item.fromUser)) return;
    if (String(item.message.roomId) !== String(currentRoomId)) return;
    if (item.message._streaming) return;
    if (String(item.message.id || '').indexOf('welcome_') === 0) return;
    if (!item.message.body || !String(item.message.body.content || '').trim()) return;
    pendingLocalAiReplyCount = Math.max(0, pendingLocalAiReplyCount - 1);
    updateActionTabsVisibility();
  }

  function maybeUnlockHumanTransferAfterCustomerMessage(item) {
    if (!item || !item.message || !isSelfMessageItem(item)) return;
    if (String(item.message.roomId) !== String(currentRoomId)) return;
    if (item.message._pending || item.message._failed) return;
    if (String(item.message.type) !== '1' && String(item.message.type) !== '20') return;
    if (!item.message.body || !String(item.message.body.content || '').trim()) return;

    var msgId = getCustomerMessageCountKey(item);
    if (countedLocalAiReplyIds[msgId]) return;

    localAiReplyCount++;
    countedLocalAiReplyIds[msgId] = true;
    updateActionTabsVisibility();
    if (localAiReplyCount < HUMAN_TRANSFER_AI_REPLY_THRESHOLD) return;

    unlockHumanTransfer();
    updateActionTabsVisibility();
  }

  function getAiReplyCountKey(item) {
    var msg = item && item.message || {};
    if (msg.id != null && msg.id !== '') return String(msg.id);
    var body = msg.body || {};
    var content = String(body.content || '').slice(0, 120);
    var sendTime = msg.sendTimeStamp != null ? msg.sendTimeStamp : msg.sendTime;
    return [
      msg.roomId || currentRoomId || '',
      parseMessageSendTime(sendTime) || '',
      content
    ].join('|');
  }

  function getAiReplyContentFingerprint(item) {
    var msg = item && item.message || {};
    var body = msg.body || {};
    var content = normalizePromptText(body.content || '').slice(0, 500);
    if (!content) return '';
    return ['ai_reply_content', msg.roomId || currentRoomId || '', content].join('|');
  }

  function getCustomerMessageCountKey(item) {
    var msg = item && item.message || {};
    if (msg.id != null && msg.id !== '') return 'customer_msg_id|' + String(msg.id);
    var body = msg.body || {};
    var sendTime = msg.sendTimeStamp != null ? msg.sendTimeStamp : msg.sendTime;
    return [
      'customer_msg',
      msg.roomId || currentRoomId || '',
      parseMessageSendTime(sendTime) || '',
      normalizePromptText(body.content || '').slice(0, 120)
    ].join('|');
  }

  function hasPendingAiReply() {
    if (pendingLocalAiReplyCount > 0 && conversationMode !== 'human') return true;
    if (activeAiStream && String(activeAiStream.roomId) === String(currentRoomId)) return true;
    return messages.some(function (item) {
      if (!item || !item.message) return false;
      if (String(item.message.roomId) !== String(currentRoomId)) return false;
      var msgId = item.message.id != null ? String(item.message.id) : '';
      return !!(item.message._streaming || (msgId && streamingByMsgId[msgId]));
    });
  }

  function shouldIgnoreInterruptedAiMessage(item) {
    if (!interruptedAiRoomId || !item || !item.message) return false;
    if (String(item.message.roomId) !== String(interruptedAiRoomId)) return false;
    if (isSelfMessageItem(item)) return false;
    if (isHumanAgentGreetingItem(item, item.message.roomId || currentRoomId)) return false;
    if (isCancelOrderMessageItem(item)) return false;
    var msgId = item.message.id != null ? String(item.message.id) : '';
    if (msgId && ignoredInterruptedMsgIds[msgId]) return true;
    if (interruptedAiUntil && Date.now() < interruptedAiUntil) return true;
    return conversationMode !== 'human' || isBotSender(item.fromUser);
  }

  function shouldIgnoreInterruptedAiFrame(frame) {
    if (!interruptedAiRoomId) return false;
    var roomId = getFrameRoomId(frame, true);
    return !roomId || String(roomId) === String(interruptedAiRoomId);
  }

  function interruptActiveAiReply() {
    if (!currentRoomId) return;

    interruptedAiRoomId = currentRoomId;
    ignoredInterruptedMsgIds = {};
    interruptedAiUntil = Date.now() + 15000;
    pendingHumanTransfer = false;

    if (activeAiStream && String(activeAiStream.roomId) === String(currentRoomId)) {
      delete streamingByMsgId[activeAiStream.msgId];
      var activeMsgId = activeAiStream.msgId;
      messages = messages.filter(function (item) {
        return !(item.message && String(item.message.id) === String(activeMsgId));
      });
      activeAiStream = null;
    }

    Object.keys(streamingByMsgId).forEach(function (msgId) {
      var idx = messages.findIndex(function (item) {
        return item.message && String(item.message.id) === String(msgId) &&
          String(item.message.roomId) === String(currentRoomId);
      });
      if (idx >= 0 && !isHumanAgentSender(messages[idx].fromUser)) {
        delete streamingByMsgId[msgId];
        messages.splice(idx, 1);
      }
    });

    renderMessages();
  }

  function handleHumanAgentGreetingMessage(item) {
    if (!item || !item.message) return false;
    var roomId = item.message.roomId || currentRoomId;
    if (!isHumanAgentGreetingItem(item, roomId)) return false;

    if (roomId) activateRoomFromWsEvent(String(roomId), 'human');
    if (roomId && (item.message.roomId == null || item.message.roomId === '')) item.message.roomId = roomId;
    if (hasPendingAiReply()) interruptActiveAiReply();
    item.message._humanAgent = true;
    return true;
  }

  function appendHumanAgentGreetingMessage(item, shouldAck) {
    if (!item || !item.message) return false;
    item = normalizeSpecialMessage(item);
    var roomId = item.message.roomId || currentRoomId;
    if (!isHumanAgentGreetingItem(item, roomId)) return false;

    if (roomId) activateRoomFromWsEvent(String(roomId), 'human');
    if (roomId && (item.message.roomId == null || item.message.roomId === '')) item.message.roomId = roomId;
    if (hasPendingAiReply()) interruptActiveAiReply();

    item.message._humanAgent = true;
    markRealtimeMessageOrder(item);
    removeHumanAgentGreetingsInRoom(item.message.roomId || currentRoomId);
    messages.push(item);
    renderMessages({ scrollToBottom: true });
    if (shouldAck) ackMessage(item.message.id);
    return true;
  }

  function continuePendingHumanTransferIfReady() {
    if (!pendingHumanTransfer || hasPendingAiReply()) return;
    requestHumanTransfer();
  }

  function finalizeStreamingMessage(data, msgId) {
    if (!msgId || !data || !data.message) return;
    markHumanAgentMessage(data);

    var stream = streamingByMsgId[msgId];
    if (stream) {
      if (!data.message.body) data.message.body = {};
      if (!data.message.body.content && stream.content) {
        data.message.body.content = stream.content;
      }
      delete streamingByMsgId[msgId];
    }
    if (activeAiStream && String(activeAiStream.msgId) === String(msgId)) {
      activeAiStream = null;
    }

    data.message._streaming = false;

    var idx = messages.findIndex(function (m) { return m.message && String(m.message.id) === String(msgId); });
    if (idx >= 0) {
      if (messages[idx].message && messages[idx].message._sortTime != null) {
        data.message._sortTime = messages[idx].message._sortTime;
      }
      messages[idx] = data;
    }
    else {
      var exists = messages.some(function (m) { return m.message && String(m.message.id) === String(msgId); });
      if (!exists) messages.push(data);
    }

    if (String(data.message.roomId) === String(currentRoomId)) {
      renderMessages();
      maybeUnlockHumanTransferAfterAiReply(data);
      continuePendingHumanTransferIfReady();
    }
  }

  function ackMessage(msgId) {
    if (msgId) wsSend({ type: 15, data: JSON.stringify({ msgId: msgId }) });
  }

  function isRemoteStreamWithoutStart(data, msgId) {
    var id = String(msgId || '');
    if (!data || !data.message || !isBackendStreamMessageId(id)) return false;
    if (activeAiStream && String(activeAiStream.roomId) === String(data.message.roomId)) return false;
    return true;
  }

  function waitForRemoteStreamEnd(roomId) {
    waitingRemoteStreamEnd = true;
    waitingRemoteStreamRoomId = String(roomId || currentRoomId || '');
    setRemoteStreamLoading(true);
  }

  function finishRemoteStreamLoading(roomId) {
    if (!waitingRemoteStreamEnd) return false;
    if (waitingRemoteStreamRoomId && roomId && String(roomId) !== String(waitingRemoteStreamRoomId)) return false;

    waitingRemoteStreamEnd = false;
    waitingRemoteStreamRoomId = '';
    setTimeout(function () {
      loadMessages().then(function () {
        setRemoteStreamLoading(false);
      });
    }, 500);
    return true;
  }

  function handleRemoteStreamWithoutStartMessage(data, envelope, shouldAck) {
    if (!data || !data.message) return false;
    normalizeMessageRoomId(data);
    if (String(data.message.roomId) !== String(currentRoomId)) return false;

    var msgId = getStreamMsgId(data) || data.message.id;
    if (!isRemoteStreamWithoutStart(data, msgId)) return false;

    waitForRemoteStreamEnd(data.message.roomId);
    if (isStreamFinished(envelope, data)) {
      finishRemoteStreamLoading(data.message.roomId);
    }
    if (shouldAck) ackMessage(data.message.id);
    return true;
  }

  function handleStreamPayload(data, envelope) {
    if (!data || !data.message) return;
    normalizeMessageRoomId(data);
    if (String(data.message.roomId) !== String(currentRoomId)) return;
    if (shouldIgnoreInterruptedAiFrame(envelope)) {
      var ignoredMsgId = getStreamMsgId(data) || data.message.id;
      if (ignoredMsgId) ignoredInterruptedMsgIds[String(ignoredMsgId)] = true;
      ackMessage(data.message.id);
      return;
    }
    markHumanAgentMessage(data);

    if (!isOpen) showBadge();

    var msgId = getStreamMsgId(data);
    if (!msgId) msgId = 'stream_' + Date.now();
    if (isRemoteStreamWithoutStart(data, msgId)) {
      waitForRemoteStreamEnd(data.message.roomId);
      if (isStreamFinished(envelope, data)) {
        finishRemoteStreamLoading(data.message.roomId);
      }
      ackMessage(data.message.id);
      return;
    }
    msgId = adoptActiveAiStreamMsgId(String(msgId), data.message.roomId);

    if (!streamingByMsgId[msgId]) {
      startStreamingMessage(data, msgId);
    }

    applyStreamDelta(msgId, data);
    updateStreamingBubble(msgId);

    if (isStreamFinished(envelope, data)) {
      finalizeStreamingMessage(data, msgId);
      ackMessage(data.message.id);
    }
  }

  // ─── 追加单条消息 ────────────────────────────────────────────────────────────
  function appendMessage(item, shouldAck) {
    normalizeMessageRoomId(item);
    if (shouldAck) markRealtimeMessageOrder(item);
    var isRestartWelcome = isRestartWelcomeMessageItem(item);
    if (isRestartWelcome) {
      handleRestartWelcomeMessage(item.message && item.message.roomId);
    }
    normalizeMessageSendTime(item && item.message);
    if (item && item.message && String(item.message.type) === '25') {
      if (shouldAck) ackMessage(item.message.id);
      if (!item.message.roomId || String(item.message.roomId) === String(currentRoomId)) {
        appendSessionEndedMessage(item);
        handleSessionEnded();
      }
      return;
    }
    item = normalizeSpecialMessage(item);

    var msgId = item.message && item.message.id;
    if (shouldIgnoreInterruptedAiMessage(item)) {
      if (shouldAck) ackMessage(msgId);
      return;
    }
    markHumanAgentMessage(item);
    var isHumanGreeting = handleHumanAgentGreetingMessage(item);
    if (!isRestartWelcome && isWelcomeMessageItem(item) && hasLatestWelcomeMessage(item.message && item.message.roomId)) {
      if (shouldAck) ackMessage(msgId);
      return;
    }
    if (item.message && isHumanAgentGreetingItem(item, item.message.roomId || currentRoomId)) {
      var greetingRoomId = item.message.roomId || currentRoomId;
      if (messages.some(function (m) {
        return isHumanAgentGreetingItem(m, greetingRoomId);
      })) {
        if (shouldAck) ackMessage(msgId);
        return;
      }
    }
    var tempId = item.message && item.message.tempId;
    var replacedTemp = false;
    if (tempId) {
      var tempIdx = messages.findIndex(function (m) {
        return m.message && String(m.message.id) === String(tempId);
      });
      if (tempIdx >= 0) {
        if (messages[tempIdx].message && messages[tempIdx].message._sortTime != null) {
          item.message._sortTime = messages[tempIdx].message._sortTime;
        }
        messages[tempIdx] = item;
        replacedTemp = true;
      }
    }
    if (activeAiStream && item.message && String(item.message.roomId) === String(activeAiStream.roomId) &&
      !isSelfMessageItem(item) && !isHumanGreeting && isBackendStreamMessageId(getStreamMsgId(item) || msgId)) {
      if (appendActiveAiStreamText(getFrameStreamText({ data: item }))) {
        if (shouldAck) ackMessage(msgId);
        return;
      }
    }

    if (msgId && streamingByMsgId[msgId]) {
      finalizeStreamingMessage(item, String(msgId));
      if (shouldAck) ackMessage(msgId);
      return;
    }

    ensureHumanGreetingBeforeMessage(item);

    // 去重
    var exists = messages.some(function (m) { return m.message && m.message.id === msgId; });
    if (!exists && !replacedTemp) messages.push(item);

    if (!isOpen) {
      showBadge();
    }

    // 只有当前会话的消息才刷新视图
    if (item.message && String(item.message.roomId) === String(currentRoomId)) {
      renderMessages();
      maybeUnlockHumanTransferAfterCustomerMessage(item);
      maybeUnlockHumanTransferAfterAiReply(item);
      continuePendingHumanTransferIfReady();
      if (shouldAck) ackMessage(msgId);
    }
  }

  function appendSessionEndedMessage(item) {
    if (!item || !item.message) return;

    normalizeMessageSendTime(item.message);
    var msg = item.message;
    var body = msg.body || {};
    if (!String(body.content || '').trim()) return;

    msg.body = body;
    msg._originalType = msg.type;
    msg.type = 1;
    if (!item.fromUser || String(item.fromUser.uid) === String(currentUid)) {
      item.fromUser = { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT' };
    }

    var msgId = msg.id;
    var exists = msgId && messages.some(function (m) {
      return m.message && String(m.message.id) === String(msgId);
    });
    if (!exists) messages.push(item);
    renderMessages({ scrollToBottom: true });
  }

  function appendSessionEndedFrameMessage(frame) {
    if (!frame) return;

    if (frame.data && frame.data.message) {
      appendSessionEndedMessage(frame.data);
      return;
    }

    if (frame.message) {
      appendSessionEndedMessage({ fromUser: frame.fromUser, message: frame.message });
      return;
    }

    var data = frame.data && typeof frame.data === 'object' ? frame.data : {};
    var body = frame.body || data.body || (data.content ? data : {});
    if (!String(body.content || '').trim()) return;

    appendSessionEndedMessage({
      fromUser: frame.fromUser || { uid: 'support_bot', name: 'Intelligent Customer Service', type: 'BOT' },
      message: {
        id: frame.id || data.id || 'session_end_' + Date.now(),
        roomId: getFrameRoomId(frame, true) || currentRoomId,
        type: 25,
        body: body,
        sendTime: frame.sendTime || data.sendTime || Date.now()
      }
    });
  }

  // ─── 发送消息 ────────────────────────────────────────────────────────────────
  function sendMessage() {
    var input = document.getElementById('lhim-input');
    var content = input.value.trim();
    if (sessionEnded) {
      showStatus(STATUS_START_NEW_CONVERSATION, 'error');
      return;
    }
    if (!content || !currentRoomId) return;

    var sendBtn = document.getElementById('lhim-send');
    sendBtn.disabled = true;
    input.value = '';

    var localSendTime = Date.now();
    var tempId = 'local_' + localSendTime;
    var localMessage = {
      fromUser: { uid: currentUid, name: 'Me' },
      message: {
        id: tempId,
        roomId: currentRoomId,
        type: 1,
        body: { content: content },
        sendTime: localSendTime,
        _sortTime: localSendTime,
        _pending: true
      }
    };
    messages.push(localMessage);
    var localAiReplyPending = markLocalAiReplyPending();
    if (!localAiReplyPending || !startActiveAiStream(currentRoomId, localSendTime + 1)) {
      renderMessages();
    }

    apiRequest('/sigen-im/chat/msg', 'POST', {
      roomId: currentRoomId,
      msgType: 1,
      body: { content: content }
    }).then(function (res) {
      sendBtn.disabled = false;
      if (res.ok && res.data && res.data.code === 0 && res.data.data) {
        res.data.data.message = res.data.data.message || {};
        res.data.data.message.tempId = tempId;
        appendMessage(res.data.data);
      } else {
        rollbackLocalAiReplyPending(localAiReplyPending);
        clearEmptyActiveAiStream(currentRoomId);
        markLocalMessageFailed(tempId);
        showStatus(STATUS_FAILED_TO_SEND, 'error');
        console.error('[LuohuoIM] 发送消息失败', res);
      }
    }).catch(function () {
      sendBtn.disabled = false;
      rollbackLocalAiReplyPending(localAiReplyPending);
      clearEmptyActiveAiStream(currentRoomId);
      markLocalMessageFailed(tempId);
      showStatus(STATUS_NETWORK_ERROR, 'error');
    });
  }

  function markLocalMessageFailed(tempId) {
    var idx = messages.findIndex(function (item) {
      return item.message && String(item.message.id) === String(tempId);
    });
    if (idx < 0) return;
    messages[idx].message._pending = false;
    messages[idx].message._failed = true;
    renderMessages();
  }

  // function sendPresetMessage(content, onComplete) {
  //   if (sessionEnded) {
  //     showStatus(STATUS_START_NEW_CONVERSATION, 'error');
  //     return;
  //   }
  //   if (!content || !currentRoomId) return;

  //   apiRequest('/sigen-im/chat/msg', 'POST', {
  //     roomId: currentRoomId,
  //     msgType: 1,
  //     body: { content: content }
  //   }).then(function (res) {
  //     if (res.ok && res.data && res.data.code === 0 && res.data.data) {
  //       appendMessage(res.data.data);
  //       if (onComplete) onComplete();
  //     } else {
  //       showStatus(STATUS_FAILED_TO_SEND, 'error');
  //       console.error('[LuohuoIM] 发送预设消息失败', res);
  //     }
  //   }).catch(function () {
  //     showStatus(STATUS_NETWORK_ERROR, 'error');
  //   });
  // }

  function openAttachmentPicker() {
    var input = document.getElementById('lhim-attachment-input');
    if (input) input.click();
  }

  function handleAttachmentChange(e) {
    var input = e.target;
    var files = input.files ? Array.prototype.slice.call(input.files) : [];
    input.value = '';
    if (!files.length) return;
    if (sessionEnded) {
      showStatus(STATUS_START_NEW_CONVERSATION, 'error');
      return;
    }
    if (!currentRoomId) {
      showStatus(STATUS_START_CONVERSATION_BEFORE_UPLOAD, 'error');
      return;
    }
    var oversized = files.some(function (file) { return file.size > MAX_ATTACHMENT_SIZE; });
    if (oversized) {
      showStatus(STATUS_FILE_TOO_LARGE, 'error');
      return;
    }
    sendImMessageWithAttachments(files.map(function (file) {
      return { file: file, name: file.name };
    }));
  }

  function sendImMessageWithAttachments(attachments) {
    if (!attachments.length) {
      showStatus(STATUS_NO_ATTACHMENT_SELECTED, 'error');
      return;
    }

    showStatus(STATUS_UPLOADING_ATTACHMENT, 'connecting');

    return attachments.reduce(function (chain, att) {
      return chain.then(function () {
        return uploadAndSendAttachment(att.file, att.name);
      });
    }, Promise.resolve()).then(function () {
      showStatus(STATUS_ATTACHMENT_SENT, 'connected');
    }).catch(function (error) {
      showStatus(STATUS_ATTACHMENT_UPLOAD_FAILED, 'error');
      console.error('[LuohuoIM] 附件发送失败', error);
    });
  }

  function uploadAndSendAttachment(file, name) {
    var formData = new FormData();
    formData.append('file', file);

    return apiFormRequest(ATTACHMENT_UPLOAD_PATH, formData).then(function (res) {
      if (!res.ok || !res.data || res.data.code !== 0) {
        throw res;
      }

      var payload = res.data.data || {};
      if (!payload.url) {
        throw { code: -1, msg: '文件上传失败', data: payload };
      }

      return sendAttachmentMessage(file, name || file.name, payload);
    });
  }

  function sendAttachmentMessage(file, name, uploadData) {
    var msgType = getAttachmentMsgType(file);
    var localAiReplyPending = false;
    var body = {
      url: uploadData.url,
      size: file.size
    };

    if (msgType === 4) {
      body.fileName = name || file.name;
    }

    if (msgType === 6) {
      body.thumbUrl = uploadData.url;
      body.thumbWidth = 100;
      body.thumbHeight = 100;
      body.thumbSize = 0;
    }

    return enrichAttachmentBody(file, msgType, body).then(function (nextBody) {
      localAiReplyPending = markLocalAiReplyPending();
      return apiRequest('/sigen-im/chat/msg', 'POST', {
        roomId: currentRoomId,
        msgType: msgType,
        body: nextBody
      });
    }).then(function (res) {
      if (!res.ok || !res.data || res.data.code !== 0) {
        rollbackLocalAiReplyPending(localAiReplyPending);
        throw res;
      }
      if (res.data.data) appendMessage(res.data.data);
      return res;
    });
  }

  function getAttachmentMsgType(file) {
    if (file.type && file.type.indexOf('image/') === 0) return 3;
    if (file.type && file.type.indexOf('video/') === 0) return 6;
    return 4;
  }

  function enrichAttachmentBody(file, msgType, body) {
    if (msgType !== 3) return Promise.resolve(body);
    return getImageDimensions(file).then(function (size) {
      body.width = size.width;
      body.height = size.height;
      return body;
    });
  }

  function getImageDimensions(file) {
    return new Promise(function (resolve) {
      var img = new Image();
      var objectUrl = URL.createObjectURL(file);
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);
        resolve({ width: img.naturalWidth || img.width, height: img.naturalHeight || img.height });
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        resolve({ width: 0, height: 0 });
      };
      img.src = objectUrl;
    });
  }

  function cancelOrderFlow() {
    if (!currentRoomId) {
      initSession();
      return;
    }
    if (cancellingOrder || transferringToHuman) return;

    var cancelBtn = document.getElementById('lhim-cancel-order');

    if (conversationMode === 'human') {
      appendCancelOrderAgentMessage();
      notifyCancelOrderMessage(cancelBtn);
      return;
    }

    if (pendingHumanTransfer) {
      showStatus(STATUS_TRANSFERRING_TO_HUMAN, 'connecting');
      return;
    }
    if (hasPendingAiReply()) {
      interruptActiveAiReply();
    }

    requestHumanTransfer({
      onSuccess: function () {
        appendCancelOrderAgentMessage();
        notifyCancelOrderMessage(cancelBtn);
      }
    });
  }

  function notifyCancelOrderMessage(cancelBtn) {
    cancellingOrder = true;
    if (cancelBtn) cancelBtn.disabled = true;

    apiRequest('/sigen-im/chat/cs/user/cancel_order/dtc', 'GET', {
      roomId: currentRoomId,
      msgType: 1,
      body: { content: CANCEL_ORDER_PROMPT }
    }).then(function (res) {
      if (!res.ok || !res.data || res.data.code !== 0) {
        console.error('[LuohuoIM] 取消订单消息记录失败', res);
      }
    }).catch(function (error) {
      console.error('[LuohuoIM] 取消订单消息记录异常', error);
    }).then(function () {
      cancellingOrder = false;
      if (cancelBtn) cancelBtn.disabled = false;
    });
  }

  // ─── 推荐问题 ────────────────────────────────────────────────────────────────
  // function loadTips() {
  //   apiRequest('/sigen-im/chat/cs/recommend-questions', 'GET').then(function (res) {
  //     if (res.ok && res.data && res.data.code === 0 && res.data.data && res.data.data.length > 0) {
  //       var tipsEl = document.getElementById('lhim-tips');
  //       var list = document.getElementById('lhim-tips-list');
  //       list.innerHTML = res.data.data.map(function (tip) {
  //         return '<div class="lhim-tip" data-tip="' + escapeAttr(tip.tip) + '" data-text="' + escapeAttr(tip.text) + '">' + escapeHtml(tip.text) + '</div>';
  //       }).join('');

  //       // 点击推荐问题
  //       list.querySelectorAll('.lhim-tip').forEach(function (el) {
  //         el.addEventListener('click', function () {
  //           sendTip(el.dataset.tip, el.dataset.text);
  //         });
  //       });

  //       tipsEl.style.display = 'block';
  //     }
  //   });
  // }

  // function sendTip(tipId, tipText) {
  //   if (!currentRoomId) return;

  //   var sendBtn = document.getElementById('lhim-send');
  //   sendBtn.disabled = true;

  //   apiRequest('/sigen-im/chat/msg', 'POST', {
  //     roomId: currentRoomId,
  //     msgType: 20,
  //     tip: tipId,
  //     body: { content: tipText }
  //   }).then(function (res) {
  //     sendBtn.disabled = false;
  //     if (res.ok && res.data && res.data.code === 0 && res.data.data) {
  //       appendMessage(res.data.data);
  //     }
  //   }).catch(function () {
  //     sendBtn.disabled = false;
  //   });
  // }

  // ─── 转人工 ──────────────────────────────────────────────────────────────────
  function transferToHuman() {
    if (!currentRoomId) return;
    if (conversationMode === 'human') {
      pendingHumanTransfer = false;
      transferringToHuman = false;
      updateHumanTransferVisibility();
      showStatus(STATUS_CURRENTLY_CONNECTED_TO_HUMAN, 'connected');
      return;
    }
    if (pendingHumanTransfer) {
      showStatus(STATUS_TRANSFERRING_TO_HUMAN, 'connecting');
      return;
    }
    if (hasPendingAiReply()) {
      interruptActiveAiReply();
    }
    requestHumanTransfer();
  }

  function requestHumanTransfer(options) {
    options = options || {};
    if (!currentRoomId) return;
    pendingHumanTransfer = false;
    transferringToHuman = true;
    updateHumanTransferVisibility();
    showStatus(STATUS_TRANSFERRING_TO_HUMAN, 'connecting');
    apiRequest('/sigen-im/chat/cs/transfer/zendesk', 'POST', { roomId: currentRoomId }).then(function (res) {
      transferringToHuman = false;
      if (res.ok && res.data && res.data.code === 0) {
        switchToHumanMode();
        appendHumanAgentGreeting();
        if (options.onSuccess) options.onSuccess();
        showStatus(STATUS_CONNECTED_TO_HUMAN, 'connected');
      } else {
        updateHumanTransferVisibility();
        showStatus(STATUS_TRANSFER_FAILED, 'error');
      }
    }).catch(function () {
      transferringToHuman = false;
      updateHumanTransferVisibility();
      showStatus(STATUS_TRANSFER_FAILED, 'error');
    });
  }

  // ─── WebSocket ───────────────────────────────────────────────────────────────
  function connectWebSocket() {
    if (!currentUid || !WS_URL) return;
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) return;

    localStorage.setItem('lhim_uid', currentUid);

    var clientId = getFingerprint();
    var url = WS_URL + '?uid=' + encodeURIComponent(currentUid) + '&clientId=' + encodeURIComponent(clientId);

    ws = new WebSocket(url);

    ws.onopen = function () {
      showStatus(STATUS_CONNECTED, 'connected');
      wsSend({ type: 2 });
      startHeartbeat();
    };

    ws.onmessage = function (e) {
      handleWsMessage(e.data);
    };

    ws.onerror = function (event) {
      var target = event && (event.currentTarget || event.target || event.srcElement);
      console.warn('[LuohuoIM] WebSocket error', {
        url: WS_URL,
        uid: currentUid,
        roomId: currentRoomId,
        type: event && event.type,
        readyState: target && target.readyState
      });
      showStatus(STATUS_CONNECTION_ERROR, 'error');
    };

    ws.onclose = function (event) {
      console.warn('[LuohuoIM] WebSocket closed', {
        code: event.code,
        reason: event.reason,
        wasClean: event.wasClean,
        roomId: currentRoomId
      });
      ws = null;
      stopHeartbeat();
      if (currentRoomId) {
        reconnectTimer = setTimeout(function () {
          reconnectTimer = null;
          connectWebSocket();
        }, WS_RECONNECT_DELAY);
      }
    };
  }

  function disconnectWebSocket() {
    if (reconnectTimer) {
      clearTimeout(reconnectTimer);
      reconnectTimer = null;
    }
    stopHeartbeat();
    if (ws) {
      ws.onclose = null;
      ws.close();
      ws = null;
    }
  }

  function wsSend(obj) {
    if (ws && ws.readyState === WebSocket.OPEN) {
      ws.send(JSON.stringify(obj));
    }
  }

  function handleWsMessage(raw) {
    try {
      var msg = JSON.parse(raw);
      var type = msg.type;

      // AI 流式开始
      if (type === 'aiStreamStart') {
        var startRoomId = getFrameRoomId(msg, true);
        if (String(startRoomId) !== String(currentRoomId)) return;
        if (shouldIgnoreInterruptedAiFrame(msg)) return;
        startActiveAiStream(startRoomId);
        return;
      }

      if (type === 'aiStreamTransfer') {
        var transferStreamRoomId = getFrameRoomId(msg, true) || currentRoomId;
        if (String(transferStreamRoomId) !== String(currentRoomId)) return;
        if (shouldIgnoreInterruptedAiFrame(msg)) return;
        handleAiStreamTransfer(transferStreamRoomId);
        return;
      }

      // AI 流式结束
      if (isAiStreamEndWsType(type)) {
        var endRoomId = getFrameRoomId(msg, true);
        if (waitingRemoteStreamEnd && (!endRoomId || String(endRoomId) === String(currentRoomId) ||
          String(endRoomId) === String(waitingRemoteStreamRoomId))) {
          if (finishRemoteStreamLoading(endRoomId || currentRoomId)) return;
        }
        if (String(endRoomId) !== String(currentRoomId)) return;
        if (shouldIgnoreInterruptedAiFrame(msg)) return;
        finishActiveAiStream(endRoomId);
        return;
      }

      if (type === 'receiveStreamMessage' || type === 'streamMessage' || type === 'messageStream' || type === 'streamChunk') {
        if (waitingRemoteStreamEnd && isStreamFinished(msg, msg.data || msg)) {
          var streamEndRoomId = getFrameRoomId(msg, true);
          finishRemoteStreamLoading(streamEndRoomId || currentRoomId);
          return;
        }
        handleStreamPayload(msg.data || msg, msg);
        return;
      }

      if (type === 'receiveMessage' && msg.data) {
        if (waitingRemoteStreamEnd && isStreamFinished(msg, msg.data)) {
          var receiveEndRoomId = getFrameRoomId(msg, true);
          finishRemoteStreamLoading(receiveEndRoomId || currentRoomId);
          ackMessage(msg.data.message && msg.data.message.id);
          return;
        }
        if (handleRemoteStreamWithoutStartMessage(msg.data, msg, true)) {
          return;
        }
        if (isStreamEnvelope(msg)) {
          handleStreamPayload(msg.data, msg);
          return;
        }
        if (appendHumanAgentGreetingMessage(msg.data, true)) {
          return;
        }
        if (shouldIgnoreInterruptedAiMessage(msg.data)) {
          ackMessage(msg.data.message && msg.data.message.id);
          return;
        }
        appendMessage(msg.data, true);
        return;
      }

      if (isHumanTransferWsType(type)) {
        var transferRoomId = getFrameRoomId(msg, true);
        if (activateRoomFromWsEvent(transferRoomId, 'human')) {
          appendHumanAgentGreeting();
        }
        return;
      }

      if (String(type) === '24') {
        var cancelOrderRoomId = getFrameRoomId(msg, true);
        if (activateRoomFromWsEvent(cancelOrderRoomId, 'human')) {
          appendHumanAgentGreeting();
          appendCancelOrderAgentMessage();
        }
        return;
      }

      if (String(type) === '25') {
        var endedRoomId = getFrameRoomId(msg, true);
        if (!endedRoomId || String(endedRoomId) === String(currentRoomId)) {
          appendSessionEndedFrameMessage(msg);
          handleSessionEnded();
        }
        return;
      }

      if (String(type) === '22') {
        var welcomeRoomId = getFrameRoomId(msg, true);
        if (handleRestartWelcomeMessage(welcomeRoomId)) {
          appendWelcomeMessage({ force: true });
        }
        return;
      }

      if (String(type) === '26') {
        var supportHoursRoomId = getFrameRoomId(msg, true);
        if (!supportHoursRoomId || String(supportHoursRoomId) === String(currentRoomId)) {
          appendSupportHoursMessage();
        }
        return;
      }

      if (shouldIgnoreInterruptedAiFrame(msg)) return;

      if (handleActiveAiStreamFrame(msg)) {
        return;
      }
    } catch (e) {
      console.warn('[LuohuoIM] WS message parse error', e);
    }
  }

  function startHeartbeat() {
    stopHeartbeat();
    heartbeatTimer = setInterval(function () {
      wsSend({ type: 2 });
    }, 15000);
  }

  function stopHeartbeat() {
    if (heartbeatTimer) {
      clearInterval(heartbeatTimer);
      heartbeatTimer = null;
    }
  }

  // ─── 工具函数 ────────────────────────────────────────────────────────────────
  function formatTime(ts) {
    var ms = parseMessageSendTime(ts);
    if (!ms) return '';
    var d = new Date(ms);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(str) {
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function renderMarkdown(markdown) {
    var text = String(markdown || '').replace(/\r\n?/g, '\n');
    if (!text) return '';

    var codeBlocks = [];
    text = text.replace(/```[^\n]*\n?([\s\S]*?)```/g, function (_, code) {
      var token = '\u0000CODE' + codeBlocks.length + '\u0000';
      codeBlocks.push('<pre><code>' + escapeHtml(code.replace(/^\n|\n$/g, '')) + '</code></pre>');
      return token;
    });

    var lines = text.split('\n');
    var html = [];
    var paragraph = [];
    var listType = null;
    var listItems = [];

    function flushParagraph() {
      if (!paragraph.length) return;
      html.push('<p>' + renderMarkdownInline(paragraph.join('\n')).replace(/\n/g, '<br>') + '</p>');
      paragraph = [];
    }

    function flushList() {
      if (!listType) return;
      html.push('<' + listType + '>' + listItems.map(function (item) {
        return '<li>' + renderMarkdownInline(item) + '</li>';
      }).join('') + '</' + listType + '>');
      listType = null;
      listItems = [];
    }

    lines.forEach(function (line) {
      var trimmed = line.trim();
      var heading = /^(#{1,3})\s+(.+)$/.exec(trimmed);
      var unordered = /^[-*]\s+(.+)$/.exec(trimmed);
      var ordered = /^\d+\.\s+(.+)$/.exec(trimmed);
      var quote = /^>\s?(.+)$/.exec(trimmed);

      if (!trimmed) {
        flushParagraph();
        flushList();
        return;
      }

      if (/^\u0000CODE\d+\u0000$/.test(trimmed)) {
        flushParagraph();
        flushList();
        html.push(trimmed);
      } else if (heading) {
        flushParagraph();
        flushList();
        var level = heading[1].length + 3;
        html.push('<h' + level + '>' + renderMarkdownInline(heading[2]) + '</h' + level + '>');
      } else if (unordered || ordered) {
        flushParagraph();
        var nextType = unordered ? 'ul' : 'ol';
        if (listType && listType !== nextType) flushList();
        listType = nextType;
        listItems.push((unordered || ordered)[1]);
      } else if (quote) {
        flushParagraph();
        flushList();
        html.push('<blockquote>' + renderMarkdownInline(quote[1]) + '</blockquote>');
      } else {
        flushList();
        paragraph.push(line);
      }
    });

    flushParagraph();
    flushList();

    return html.join('').replace(/\u0000CODE(\d+)\u0000/g, function (_, index) {
      return codeBlocks[Number(index)] || '';
    });
  }

  function renderMarkdownInline(text) {
    var codeSpans = [];
    var html = escapeHtml(text).replace(/`([^`]+)`/g, function (_, code) {
      var token = '\u0000INLINECODE' + codeSpans.length + '\u0000';
      codeSpans.push('<code>' + code + '</code>');
      return token;
    });

    html = html
      .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, function (_, label, url) {
        var safeUrl = sanitizeMarkdownUrl(url);
        if (!safeUrl) return label;
        return '<a href="' + escapeAttr(safeUrl) + '" target="_blank" rel="noopener noreferrer">' + label + '</a>';
      })
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/__([^_]+)__/g, '<strong>$1</strong>')
      .replace(/(^|[^*])\*([^*\n]+)\*/g, '$1<em>$2</em>')
      .replace(/(^|[^_])_([^_\n]+)_/g, '$1<em>$2</em>');

    return html.replace(/\u0000INLINECODE(\d+)\u0000/g, function (_, index) {
      return codeSpans[Number(index)] || '';
    });
  }

  function sanitizeMarkdownUrl(url) {
    var raw = String(url || '').trim();
    var decoded = raw.replace(/&amp;/g, '&');
    if (/^(https?:|mailto:|tel:)/i.test(decoded) || decoded.charAt(0) === '/') return decoded;
    return '';
  }

  // ─── 暴露公共 API（供调试和外部调用）────────────────────────────────────────
  window.__lhim = {
    closeWindow: closeWindow,
    openWindow: openWindow,
    //loadTips: loadTips,
    transferToHuman: transferToHuman,
    sendMessage: sendMessage,
    restartSession: restartSession
  };

  // ─── 启动 ────────────────────────────────────────────────────────────────────
  function init() {
    if (document.getElementById('lhim-trigger')) return; // 防止重复初始化
    injectStyle();
    buildDOM();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
